import React, { useState, useEffect } from 'react'
import { EMPTY, EMPTYSPACE, ENGLISH_FF, MANDRAIN_FF, HORIZONTALMIDDLE, MOVERIGHT, MOVELEFT, NAMEUSERS_SMALL, CONTENTEXAMPLE_SMALL, TITLE_SMALL, SUBTEXT_SMALL, BABY_SMALL, ARROWRIGHT_SMALL, ARROWLEFT_SMALL, CLOSE_ICON, STARTUP_NAME } from '../../../../../../config/constants';
import { Checkdevice } from '../../../../../../components/Checkdevice';
import { Calendar, Invdate, Modcfm } from '../../../../../../components';
import { Icon } from 'react-icons-kit/Icon'
import { arrow_left } from 'react-icons-kit/ikons/arrow_left'
import { arrow_right } from 'react-icons-kit/ikons/arrow_right'
import { inputdescribe_dom, input_dom, multiplechoice_dom, partialtitle_dom, radiobtn_dom, textarea_dom, twobtn_dom } from '../Commonelements/Commonelements'
import { HexColorInput, HexColorPicker } from 'react-colorful';
import { LOC_ICON, DATETIME_ICON, QA_ICON, SOCIALMEDIATHICK_ICON, HOWWEMET_ICON, NAMES_ICON, FONTS_ICON, DESCRIP_ICON, PROPOSAL_ICON, PROMOTE_ICON, CONTACT_ICON, NOTI_ICON, LINK_ICON, SCHEDULES_ICON, OPENING_ICON, CROSS_ICON, DRAG_ICON, THINTELEGRAM_ICON, THINWHATSAPP_ICON, THINWECHAT_ICON, THININSTAGRAM_ICON, RSVPTELEPHONE_ICON, ADD_ICON, MOBILE_ICON, LAPTOP_ICON, TABLET_ICON, REGISTRY_ICON, PARTY_ICON, SEQUENCE_ICON, IMAGES_ICON, TXTLEFT_ICON, TXTCENTER_ICON, TXTRIGHT_ICON } from '../../../../../../config/svgicons';
import { iconwrapper } from '../../../../../../config/commonfunctions';
import Explain from './../Explain'
import Schedules from '../Schedules/Schedules';
import Promote from '../Promote/Promote';
import Contacts from '../Contacts/Contacts';
import Highlighttitle from '../Highlighttitle/Highlighttitle';
import Questions from '../Questions/Questions';
import Sequence from '../Sequence/Sequence';
import Registry from '../Registry/Registry';
import Party from '../Party/Party';
import Heroimages from '../Heroimages/Heroimages';
import { AlignmentSelector } from '../../commonfunctions/commonfunctions';
import './../../Invitationedit.css'
import './Details.css'
import '../components.css'




const dragsvgcss = { width: 20, height: 20, display: 'flex', placeContent: 'center', margin: 5 }

const colors_arr = ['#333333', '#707070', '#e1d9ca', '#7b5c5c']
var secondmap = { '1s': 1000, '2s': 2000, '3s': 3000, '4s': 4000, '5s': 5000, '6s': 6000, '7s': 7000, '8s': 8000 }
var inversesecondmap = { 1000: '1s', 2000: '2s', 3000: '3s', 4000: '4s', 5000: '5s', 6000: '6s', 7000: '7s', 8000: '8s' }

const inputhalf_css = { width: '50%', margin: 0, }
const input_css = { marginLeft: 0, marginRight: 0, width: '100%', margin: 0 }
const txtarea_css = { marginLeft: 0, marginRight: 0, width: '100%', margin: 0 }
const select_css = { marginLeft: 0, marginRight: 0, width: '100%', margin: 0 }

const iconcss = { width: 25, height: 25, margin: '0px 5px 0px 0px', userSelect: 'none', pointerEvents: 'none', verticalAlign: 'middle', fill: 'currentColor', overflow: 'hidden' }
const myiconcss = { width: 42, height: 42 }

const LANG_FF_MAP = {
    'English': ENGLISH_FF,
    'Mandarin': MANDRAIN_FF,
}

const PARAMS_MEDIA_MAP = {
    'Telegram': {
        'icon': iconwrapper(THINTELEGRAM_ICON, iconcss),
        'who_placeholder': 'Jason',
        'val_placeholder': 'https://t.me/joinchat/skdmflksmdflkmdflkds'
    },
    'Whatsapp': {
        'icon': iconwrapper(THINWHATSAPP_ICON, iconcss),
        'who_placeholder': '',
        'val_placeholder': ''
    },
    'WeChat': {
        'icon': iconwrapper(THINWECHAT_ICON, iconcss),
        'who_placeholder': '',
        'val_placeholder': ''
    },
    'Instagram': {
        'icon': iconwrapper(THININSTAGRAM_ICON, iconcss),
        'who_placeholder': '',
        'val_placeholder': ''
    },
    'Number': {
        'icon': iconwrapper(RSVPTELEPHONE_ICON, iconcss),
        'who_placeholder': '',
        'val_placeholder': ''
    },
}

// const TYPE_ICON_MAP = {
//     "Names": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M875.466 674.753c-34.694-34.695-75.852-60.581-120.75-76.543 23.679-11.749 45.549-27.397 64.787-46.636 46.478-46.477 72.075-108.272 72.075-174.001s-25.597-127.524-72.075-174.002c-46.478-46.477-108.272-72.074-174.001-72.074-48.096 0-94.072 13.724-133.492 39.289-39.425-25.566-85.409-39.289-133.508-39.289-65.729 0-127.525 25.597-174.002 72.074-46.478 46.477-72.075 108.272-72.075 174.002 0 65.73 25.596 127.524 72.075 174.001 19.239 19.238 41.108 34.887 64.789 46.636-44.9 15.963-86.056 41.848-120.752 76.543C89.998 733.291 56.548 810.216 53.53 892.504l43.099 0c2.995-70.777 31.963-136.894 82.365-187.293 49.325-49.325 113.699-78.118 182.765-82.134 5.55 0.37 11.129 0.571 16.741 0.571s11.193-0.201 16.742-0.571c69.066 4.016 133.441 32.809 182.766 82.134 50.401 50.399 79.369 116.516 82.365 187.293l43.098 0c-3.017-82.288-36.467-159.213-95.005-217.751-14.726-14.726-30.619-27.858-47.465-39.325 21.792-6.812 44.504-10.998 67.758-12.351 5.55 0.37 11.129 0.571 16.741 0.571s11.193-0.201 16.742-0.571c69.066 4.016 133.441 32.809 182.766 82.134 50.401 50.399 79.369 116.516 82.365 187.293l43.098 0C967.454 810.216 934.004 733.291 875.466 674.753zM394.945 579.905c-5.457-0.269-10.939-0.407-16.443-0.407-5.503 0-10.984 0.139-16.443 0.407-104.275-8.398-186.56-95.933-186.56-202.333 0-111.937 91.066-203.004 203.003-203.004 111.937 0 203.004 91.068 203.004 203.004C581.506 483.972 499.22 571.507 394.945 579.905zM487.716 598.21c8.336-4.136 16.442-8.766 24.293-13.854 7.848 5.086 15.946 9.721 24.279 13.854-8.225 2.924-16.317 6.192-24.272 9.776C504.052 604.399 495.947 601.137 487.716 598.21zM661.945 579.905c-5.457-0.269-10.939-0.407-16.443-0.407s-10.984 0.139-16.443 0.407c-31.92-2.57-60.759-6.907-86.219-19.184 3.287-2.955 6.514-5.998 9.663-9.147 46.478-46.477 72.075-108.272 72.075-174.001s-25.597-127.524-72.075-174.002c-1.401-1.401-2.817-2.781-4.246-4.144 28.894-15.84 62.034-24.858 97.245-24.858 111.937 0 203.004 91.068 203.004 203.004C848.506 483.972 766.22 571.507 661.945 579.905zM834.074 832.574" p-id="62155"></path></svg>,
//     "Name": NAMEUSERS_SMALL,
//     "Fonts": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M940.6208 870.254933a21.367467 21.367467 0 0 0-28.219733 3.0976c-1.390933 0.964267-8.712533 5.367467-27.818667 7.2192 3.336533-41.642667 24.968533-153.9584 47.428267-254.429866a21.316267 21.316267 0 0 0-16.170667-25.472 21.256533 21.256533 0 0 0-24.942933 14.574933c-13.704533-8.046933-48.093867-24.8832-86.6048-17.792-29.226667 5.4016-53.930667 22.920533-73.429334 52.087467-13.610667 20.352-29.738667 48.213333-43.6736 78.583466-27.1104-18.346667-57.250133-37.589333-89.685333-55.714133l-58.052267-561.314133a21.333333 21.333333 0 0 0-23.415466-19.0208c-0.0512 0-0.093867 0.0256-0.136534 0.0256a21.265067 21.265067 0 0 0-21.666133 14.208L326.7584 589.841067c-42.820267 0.0256-86.621867 6.775467-130.304 23.492266-76.6464 29.329067-113.979733 108.663467-123.3664 173.141334-8.567467 58.88 4.9408 109.917867 35.259733 133.179733 20.625067 15.8208 39.9616 20.7104 55.970134 20.7104 8.251733 0 15.616-1.297067 21.819733-3.054933 66.628267-18.952533 106.24-118.9632 110.754133-130.884267l59.758934-172.526933c61.533867 5.623467 127.889067 27.383467 200.772266 65.621333l22.801067 220.424533a21.333333 21.333333 0 1 0 42.427733-4.386133l-19.703466-190.498133a1248.913067 1248.913067 0 0 1 60.8256 38.7328c2.346667 1.595733 4.906667 2.628267 7.5264 3.182933-18.824533 52.846933-25.9072 106.9312 1.1008 138.9056 14.421333 17.083733 35.6096 25.634133 63.880533 25.634133 28.433067 0 64.136533-8.763733 107.264-26.077866 1.1776 5.6576 2.9952 7.9872 4.514133 9.8816a23.04 23.04 0 0 0 18.030934 8.7296c56.3456 0 74.3936-16.827733 79.530666-24.055467a21.2992 21.2992 0 0 0-5.000533-29.738667z m-683.8272-78.3872c-9.6256 25.275733-43.195733 93.312-82.3552 104.405334-8.302933 2.3552-21.4784 3.822933-40.106667-10.4704-17.527467-13.448533-25.173333-50.901333-19.012266-93.192534 7.287467-50.0992 36.906667-116.676267 96.392533-139.434666a311.876267 311.876267 0 0 1 100.224-20.5056l-55.1424 159.197866z m114.193067-199.3472l135.048533-389.896533 46.139733 446.122667c-55.995733-27.1616-117.316267-48.904533-181.188266-56.226134z m334.011733 285.841067c-24.942933-29.533867 12.305067-131.7888 61.3376-205.1072 12.791467-19.131733 28.0832-30.498133 45.44-33.792 30.882133-5.819733 60.5696 14.421333 60.859733 14.634667 2.705067 1.8944 5.7088 3.003733 8.772267 3.498666-22.596267 104.055467-32.989867 165.0432-36.974933 201.233067-102.493867 44.612267-131.677867 28.7232-139.434667 19.5328z" p-id="59878"></path></svg>,
//     "Description": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M1004 894.4H20c-8.8 0-16-7.2-16-16V145.6c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v732c0 9.6-7.2 16.8-16 16.8z m-968-32h952V161.6H36v700.8zM335.2 712.8c-1.6 0-4-0.8-5.6-2.4-8.8-8-208.8-197.6-208.8-277.6 0-67.2 54.4-121.6 121.6-121.6 36 0 69.6 16 92.8 43.2 23.2-27.2 56.8-43.2 92.8-43.2 67.2 0 121.6 54.4 121.6 121.6 0 79.2-200 269.6-208.8 277.6-1.6 1.6-4 2.4-5.6 2.4zM242.4 327.2c-58.4 0-105.6 47.2-105.6 105.6 0 58.4 138.4 203.2 198.4 260.8 60-57.6 198.4-202.4 198.4-260.8 0-58.4-47.2-105.6-105.6-105.6-34.4 0-66.4 16.8-86.4 44.8-3.2 4-10.4 4-12.8 0-20-28-52-44.8-86.4-44.8zM895.2 318.4H653.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h241.6c4.8 0 8 3.2 8 8s-3.2 8-8 8zM895.2 520H653.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h241.6c4.8 0 8 3.2 8 8s-3.2 8-8 8zM895.2 721.6H653.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h241.6c4.8 0 8 3.2 8 8s-3.2 8-8 8z" p-id="2761"></path></svg>,
//     "Location": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M512 1020c-5.6 0-11.2-3.2-13.6-8-12.8-20.8-308-514.4-308-686.4C189.6 148.8 334.4 4 512 4s322.4 144.8 322.4 322.4c0 171.2-296 665.6-308 686.4-3.2 4-8.8 7.2-14.4 7.2z m0-984c-160 0-290.4 130.4-290.4 290.4 0 142.4 231.2 545.6 290.4 646.4 59.2-100.8 290.4-504 290.4-646.4 0-160-130.4-290.4-290.4-290.4zM512 567.2c-1.6 0-4-0.8-5.6-2.4-8-8-198.4-187.2-198.4-263.2 0-64 52-116 116-116 33.6 0 66.4 15.2 88 40.8 21.6-25.6 54.4-40.8 88-40.8 64 0 116 52 116 116 0 75.2-190.4 256-198.4 263.2-1.6 1.6-4 2.4-5.6 2.4zM424 202.4c-55.2 0-100 44.8-100 100s130.4 192 188 246.4c56.8-54.4 188-191.2 188-246.4 0-55.2-44.8-100-100-100-32 0-62.4 16-81.6 42.4-1.6 1.6-4 3.2-6.4 3.2-2.4 0-4.8-1.6-6.4-3.2-19.2-27.2-49.6-42.4-81.6-42.4z" p-id="28746"></path></svg>,
//     "Date Time": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M1004 298.4H20c-4.8 0-8-3.2-8-8V107.2c0-4.8 3.2-8 8-8h984c4.8 0 8 3.2 8 8v183.2c0 4-3.2 8-8 8z m-976-16h968V115.2H28v167.2zM1004 1020H20c-8.8 0-16-7.2-16-16V107.2c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v896.8c0 8.8-7.2 16-16 16z m-968-32h952V123.2H36v864.8zM158.4 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM291.2 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM732.8 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM865.6 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM744.8 1012c-0.8 0-2.4 0-3.2-0.8-3.2-1.6-4.8-4-4.8-7.2V744.8c0-4.8 3.2-8 8-8h259.2c3.2 0 6.4 1.6 7.2 4.8 1.6 3.2 0.8 6.4-1.6 8.8l-259.2 259.2c-1.6 1.6-3.2 2.4-5.6 2.4z m8-259.2v232l232-232h-232zM512 832.8c-50.4 0-92-13.6-123.2-40.8-32-27.2-48-60.8-48-100.8 0-44 16.8-80 49.6-108-23.2-24-34.4-52.8-34.4-84.8 0-35.2 15.2-64.8 45.6-88.8 29.6-23.2 67.2-35.2 111.2-35.2s81.6 12 111.2 35.2c30.4 24 45.6 53.6 45.6 88.8 0 32-11.2 60-33.6 84 32.8 28 49.6 64.8 49.6 108 0 40-16 73.6-48 100.8-33.6 28-75.2 41.6-125.6 41.6zM411.2 422.4c-26.4 20.8-39.2 45.6-39.2 76s12 56.8 36 79.2c1.6 1.6 2.4 4 2.4 6.4 0 2.4-1.6 4.8-3.2 5.6-33.6 25.6-50.4 59.2-50.4 101.6 0 35.2 13.6 64.8 42.4 88.8 28.8 24 66.4 36.8 112.8 36.8 46.4 0 84-12 112.8-36.8 28.8-24 42.4-53.6 42.4-88.8 0-42.4-16-75.2-50.4-101.6-1.6-1.6-3.2-4-3.2-5.6 0-2.4 0.8-4.8 2.4-6.4 24-22.4 35.2-48 35.2-79.2 0-30.4-12.8-56-39.2-76.8-26.4-20.8-60.8-32-100.8-32-39.2 0.8-73.6 12-100 32.8zM512 753.6c-18.4 0-35.2-5.6-51.2-16-16.8-11.2-24.8-27.2-24.8-48.8 0-20.8 8-37.6 24-48.8 15.2-10.4 32.8-16 52-16 19.2 0 36.8 5.6 52 16 16 11.2 24 28 24 48.8 0 20.8-8 37.6-24.8 48.8-16 10.4-32.8 16-51.2 16zM512 640c-16 0-29.6 4-42.4 13.6-12 8-17.6 20-17.6 36s5.6 27.2 17.6 35.2c12.8 8.8 27.2 12.8 41.6 12.8 15.2 0 28.8-4 42.4-12.8 12-8 17.6-19.2 17.6-35.2 0-16-5.6-27.2-17.6-36C541.6 644.8 528 640 512 640z m0-73.6c-17.6 0-32.8-5.6-45.6-16.8-13.6-11.2-20-25.6-20-42.4 0-16.8 6.4-31.2 20-42.4 12.8-11.2 28-16.8 46.4-16.8 17.6 0 33.6 5.6 46.4 16.8 13.6 11.2 20 25.6 20 42.4 0 16.8-7.2 31.2-20 42.4-14.4 11.2-29.6 16.8-47.2 16.8z m-35.2-28.8c10.4 8.8 21.6 12.8 35.2 12.8 13.6 0 25.6-4 35.2-12.8 9.6-8 14.4-18.4 14.4-30.4s-4.8-22.4-14.4-30.4c-10.4-8.8-21.6-12.8-36-12.8-14.4 0-25.6 4-36 12.8-9.6 8-14.4 18.4-14.4 30.4 0.8 12.8 5.6 22.4 16 30.4z" p-id="9500"></path></svg>,
//     "Q&A": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M239.9 339c0-152 122.1-273.7 272.2-273.7s272.2 121.4 272.2 271.5c0 114.8-72.3 217.2-180.1 256C582.4 597.3 484.1 641 484.1 868l50.5 0c0-201 79.6-226.2 79.7-226.2 1.7-0.2 3.3-0.7 4.9-1.2 129-45.3 215.7-167.7 215.7-304.5 0-177.9-144.8-321.2-322.7-321.2C334.2 14.8 189.4 162 189.4 339L239.9 339zM517.4 933.5c-20.9 0-37.8 16.9-37.8 37.8s17 37.8 37.8 37.8c20.9 0 37.8-16.9 37.8-37.8S538.3 933.5 517.4 933.5z" p-id="12305"></path></svg>,
//     'Social Media': <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M967.68 382.976c-10.24-36.864-33.792-67.584-66.56-87.04s-71.68-24.576-107.52-14.336C747.52 190.464 671.744 123.904 578.56 92.16c-91.136-30.72-187.392-26.624-274.432 10.24-25.6-30.72-65.536-51.2-109.568-51.2-78.848 0-143.36 64.512-143.36 143.36 0 41.984 18.432 79.872 48.128 106.496C55.296 392.192 49.152 496.64 81.92 589.824c33.792 95.232 103.424 173.056 195.584 217.088-10.24 71.68 33.792 141.312 104.448 159.744 12.288 3.072 24.576 5.12 36.864 5.12 24.576 0 49.152-6.144 71.68-19.456 33.792-19.456 57.344-50.176 66.56-87.04 3.072-11.264 4.096-21.504 5.12-32.768C694.272 796.672 795.648 694.272 832.512 563.2c11.264 0 22.528-2.048 33.792-5.12 36.864-9.216 68.608-33.792 87.04-66.56 19.456-32.768 24.576-71.68 14.336-108.544zM92.16 194.56c0-56.32 46.08-102.4 102.4-102.4 33.792 0 64.512 16.384 82.944 41.984 0 1.024 1.024 2.048 1.024 4.096 1.024 3.072 3.072 5.12 5.12 7.168 8.192 14.336 13.312 31.744 13.312 50.176 0 56.32-46.08 102.4-102.4 102.4S92.16 250.88 92.16 194.56z m427.008 660.48c-7.168 26.624-23.552 48.128-48.128 62.464-23.552 13.312-51.2 17.408-77.824 10.24-55.296-14.336-87.04-69.632-72.704-125.952 7.168-26.624 23.552-48.128 48.128-62.464 16.384-9.216 32.768-13.312 51.2-13.312 9.216 0 17.408 1.024 26.624 3.072 54.272 14.336 87.04 70.656 72.704 125.952z m38.912-63.488c-13.312-48.128-50.176-88.064-101.376-101.376-36.864-9.216-75.776-4.096-108.544 14.336-25.6 14.336-46.08 36.864-58.368 63.488-79.872-40.96-139.264-108.544-168.96-192.512C92.16 495.616 97.28 403.456 133.12 324.608c18.432 9.216 38.912 13.312 61.44 13.312 78.848 0 143.36-64.512 143.36-143.36 0-19.456-4.096-38.912-11.264-56.32 75.776-31.744 160.768-33.792 239.616-7.168 80.896 27.648 148.48 86.016 189.44 165.888-20.48 12.288-37.888 29.696-50.176 51.2-18.432 31.744-24.576 71.68-14.336 108.544s33.792 67.584 66.56 87.04c10.24 6.144 21.504 11.264 33.792 14.336-33.792 112.64-120.832 200.704-233.472 233.472zM918.528 471.04c-13.312 23.552-35.84 40.96-62.464 48.128-26.624 7.168-54.272 3.072-77.824-10.24s-40.96-35.84-48.128-62.464-3.072-55.296 10.24-77.824c13.312-23.552 35.84-40.96 62.464-48.128 9.216-2.048 17.408-3.072 26.624-3.072 17.408 0 35.84 5.12 51.2 14.336 23.552 13.312 40.96 35.84 48.128 62.464 6.144 25.6 3.072 53.248-10.24 76.8z" p-id="10456"></path></svg>,
//     "Content Examples": CONTENTEXAMPLE_SMALL,
//     "Title": TITLE_SMALL,
//     "Subtext": SUBTEXT_SMALL,
//     "Baby Name": BABY_SMALL,
//     'How We Met': <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M494.4 595.2c-4 0-8-1.6-11.2-4-31.2-29.6-306.4-290.4-306.4-406.4C176.8 84.8 258.4 4 358.4 4c52 0 101.6 22.4 135.2 60.8C528 26.4 576.8 4 628.8 4c100 0 181.6 80.8 181.6 180.8 0 114.4-275.2 376.8-306.4 406.4-1.6 2.4-5.6 4-9.6 4z m-136-559.2c-82.4 0-149.6 66.4-149.6 148.8S405.6 472 494.4 556.8C583.2 472 779.2 267.2 779.2 184.8c0-82.4-67.2-148.8-149.6-148.8-48.8 0-94.4 24-122.4 63.2-3.2 4-8 6.4-12.8 6.4-4.8 0-10.4-2.4-12.8-6.4-28.8-39.2-74.4-63.2-123.2-63.2zM731.2 192.8c-4.8 0-8-3.2-8-8 0-51.2-42.4-92.8-93.6-92.8-30.4 0-59.2 15.2-76.8 40-2.4 4-7.2 4.8-11.2 1.6-4-2.4-4.8-7.2-1.6-11.2 20.8-28.8 54.4-46.4 89.6-46.4 60.8 0 109.6 48.8 109.6 108.8 0 4.8-3.2 8-8 8zM514.4 1020c-62.4 0-124.8-16-186.4-31.2-80-20-162.4-41.6-240.8-24.8-8 1.6-16.8-3.2-18.4-11.2l-64-242.4c-1.6-5.6 0-12 4.8-16 62.4-58.4 136.8-120 224-111.2 41.6 4 84 24.8 125.6 61.6 4.8 4 8.8 8 12.8 12 14.4 13.6 28 25.6 44.8 34.4 16 8 35.2 12.8 52.8 16 21.6 4 44 8 66.4 11.2 44.8-32 104.8-62.4 143.2-78.4 25.6-10.4 55.2-20 84.8-10.4 14.4 4.8 28 16.8 35.2 30.4 6.4-6.4 14.4-12 22.4-16.8 22.4-12.8 56-16 80 3.2 8.8 7.2 14.4 16.8 17.6 28 10.4-5.6 22.4-9.6 35.2-11.2 18.4-1.6 38.4 5.6 51.2 19.2 11.2 12 16.8 26.4 14.4 41.6-11.2 86.4-326.4 256-417.6 283.2-29.6 9.6-58.4 12.8-88 12.8z m-366.4-94.4c63.2 0 126.4 16 188.8 32 89.6 22.4 174.4 44 256.8 20 109.6-32.8 388-200 395.2-256.8 0.8-6.4-2.4-12-5.6-15.2-6.4-6.4-16.8-10.4-25.6-9.6-16.8 1.6-32 12-48 24.8-3.2 3.2-6.4 6.4-10.4 8.8-7.2 4-16 2.4-20.8-4.8-4.8-6.4-3.2-16 2.4-21.6 1.6-1.6 4-3.2 5.6-4.8 1.6-2.4 2.4-5.6 2.4-8 0.8-7.2-2.4-14.4-7.2-18.4-12-10.4-32-7.2-44.8 0-16 8.8-28 24-38.4 38.4-0.8 1.6-1.6 2.4-3.2 4-5.6 6.4-15.2 8-22.4 2.4-7.2-5.6-8-15.2-3.2-21.6 0.8-0.8 0.8-1.6 1.6-2.4 2.4-4 1.6-8.8 0.8-12-2.4-8.8-10.4-17.6-19.2-20.8-19.2-6.4-42.4 1.6-62.4 9.6-31.2 12.8-72 32.8-107.2 54.4 37.6 4 75.2 5.6 112.8 6.4 5.6 0 14.4 0 22.4 6.4 6.4 4.8 10.4 12 10.4 20 0 13.6-8.8 26.4-17.6 34.4-107.2 92-275.2 100-390.4 18.4-7.2-4.8-8.8-15.2-4-22.4 4.8-7.2 15.2-8.8 22.4-4 102.4 72 256 64.8 351.2-16.8l4-4c-52.8-0.8-105.6-4.8-157.6-12H536c-24.8-3.2-49.6-7.2-73.6-12-20-4-41.6-8.8-61.6-19.2-20-10.4-36-24.8-51.2-39.2-4-4-8-8-12.8-11.2-36.8-32-72.8-50.4-107.2-53.6-71.2-7.2-136 44.8-192 96l58.4 218.4c17.6-2.4 34.4-4 52-4z" p-id="9878"></path></svg>,
//     'Proposal': <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M580 316c-1.6 0-4-0.8-5.6-2.4-12-11.2-69.6-66.4-69.6-93.6 0-24.8 20-44.8 44.8-44.8 11.2 0 22.4 4 30.4 12 8-7.2 19.2-12 30.4-12 24.8 0 44.8 20 44.8 44.8 0 27.2-58.4 83.2-69.6 93.6-1.6 1.6-4 2.4-5.6 2.4z m-30.4-124.8c-16 0-28.8 12.8-28.8 28.8 0 13.6 32.8 51.2 59.2 76.8 26.4-25.6 59.2-63.2 59.2-76.8 0-16-12.8-28.8-28.8-28.8-9.6 0-18.4 4.8-24 12-1.6 2.4-4 3.2-6.4 3.2-2.4 0-4.8-1.6-6.4-3.2-5.6-7.2-14.4-12-24-12zM514.4 1020c-62.4 0-124.8-16-186.4-31.2-80-20-162.4-41.6-240.8-24.8-8 1.6-16.8-3.2-18.4-11.2l-64-242.4c-1.6-5.6 0-12 4.8-16 62.4-58.4 136.8-120 224-111.2 41.6 4 84 24.8 125.6 61.6 4.8 4 8.8 8 12.8 12 14.4 13.6 28 25.6 44.8 34.4 16 8 35.2 12.8 52.8 16 21.6 4 44 8 66.4 11.2 44.8-32 104.8-62.4 143.2-78.4 25.6-10.4 55.2-20 84.8-10.4 14.4 4.8 28 16.8 35.2 30.4 6.4-6.4 14.4-12 22.4-16.8 22.4-12.8 56-16 80 3.2 8.8 7.2 14.4 16.8 17.6 28 10.4-5.6 22.4-9.6 35.2-11.2 18.4-1.6 38.4 5.6 51.2 19.2 11.2 12 16.8 26.4 14.4 41.6-11.2 86.4-326.4 256-417.6 283.2-29.6 9.6-58.4 12.8-88 12.8z m-366.4-94.4c63.2 0 126.4 16 188.8 32 89.6 22.4 174.4 44 256.8 20 109.6-32.8 388-199.2 395.2-256.8 0.8-6.4-2.4-12-5.6-15.2-6.4-6.4-16-10.4-25.6-9.6-16.8 1.6-32 12-48 24.8-3.2 3.2-6.4 6.4-10.4 8.8-7.2 4-16 1.6-20.8-4.8-4.8-6.4-3.2-16 2.4-21.6 1.6-1.6 4-3.2 5.6-4.8 1.6-2.4 2.4-5.6 2.4-8 0.8-7.2-2.4-14.4-7.2-18.4-12-10.4-32-7.2-44.8 0-16 8.8-28 24-38.4 38.4-0.8 1.6-1.6 2.4-3.2 4-5.6 6.4-15.2 8-22.4 2.4-7.2-5.6-8-15.2-3.2-21.6 0.8-0.8 0.8-1.6 1.6-2.4 2.4-4 1.6-8.8 0.8-12-2.4-8.8-10.4-17.6-19.2-20.8-19.2-6.4-42.4 1.6-62.4 9.6-31.2 12.8-72 32.8-107.2 54.4 37.6 4 75.2 5.6 112.8 6.4 5.6 0 14.4 0 22.4 6.4 6.4 4.8 10.4 12 10.4 20 0 13.6-8.8 26.4-17.6 34.4-107.2 92-275.2 100-390.4 18.4-7.2-4.8-8.8-15.2-4-22.4 4.8-7.2 15.2-8.8 22.4-4 102.4 72 256 64.8 351.2-16.8l4-4c-52.8-0.8-105.6-4.8-157.6-12H536c-24.8-3.2-49.6-7.2-73.6-12-20-4-41.6-8.8-61.6-19.2-20-10.4-36-24.8-51.2-39.2-4-4-8.8-8-12.8-11.2-36.8-32-72.8-50.4-107.2-53.6-71.2-7.2-136 44.8-192 96l58.4 218.4c17.6-2.4 34.4-4 52-4zM742.4 577.6h-336c-28.8 0-52-23.2-52-52V427.2c0-8.8 7.2-16 16-16h407.2c8.8 0 16 7.2 16 16v98.4c0.8 28.8-22.4 52-51.2 52zM387.2 443.2v82.4c0 11.2 8.8 20 20 20h336c11.2 0 20-8.8 20-20V443.2h-376zM371.2 443.2H272.8c-28.8 0-52-23.2-52-52V56c0-28.8 23.2-52 52-52h98.4c8.8 0 16 7.2 16 16v407.2c0 8.8-7.2 16-16 16zM272.8 36c-11.2 0-20 8.8-20 20v336c0 11.2 8.8 20 20 20h82.4v-376H272.8zM699.2 435.2c-4.8 0-8-3.2-8-8 0-61.6-49.6-111.2-111.2-111.2s-111.2 49.6-111.2 111.2c0 4.8-3.2 8-8 8s-8-3.2-8-8c0-70.4 56.8-127.2 127.2-127.2s127.2 56.8 127.2 127.2c0 4.8-4 8-8 8z" p-id="12406"></path></svg>,
//     'Promote': <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M682.666667 955.733333c-2.6112 0-5.2224-0.597333-7.6288-1.792L512 872.413867l-163.037867 81.5104A17.066667 17.066667 0 0 1 324.266667 938.666667V733.201067a380.0576 380.0576 0 0 1-65.826134-52.974934C188.8768 610.6624 153.6 525.346133 153.6 426.666667s35.2768-183.995733 104.840533-253.559467S413.320533 68.266667 512 68.266667s183.995733 35.2768 253.559467 104.840533S870.4 327.9872 870.4 426.666667s-35.259733 183.978667-104.840533 253.559466A382.293333 382.293333 0 0 1 699.733333 733.201067V938.666667a17.083733 17.083733 0 0 1-17.066666 17.066666z m-170.666667-119.466666c2.6112 0 5.239467 0.597333 7.6288 1.792L665.6 911.0528v-159.146667C619.025067 773.9392 567.483733 785.066667 512 785.066667c-55.5008 0-107.042133-11.127467-153.6-33.143467v159.1296l145.9712-72.977067A16.896 16.896 0 0 1 512 836.266667z m-162.030933-127.351467C397.704533 736.802133 452.215467 750.933333 512 750.933333c59.7504 0 114.261333-14.1312 162.030933-42.018133a342.784 342.784 0 0 0 67.396267-52.821333C804.369067 593.152 836.266667 515.959467 836.266667 426.666667s-31.8976-166.485333-94.839467-229.4272C678.485333 134.314667 601.2928 102.4 512 102.4s-166.485333 31.914667-229.4272 94.839467S187.733333 337.373867 187.733333 426.666667s31.914667 166.485333 94.839467 229.4272a342.784 342.784 0 0 0 67.396267 52.821333zM512 699.733333c-74.9056 0-139.8272-26.948267-192.9728-80.093866C265.8816 566.493867 238.933333 501.572267 238.933333 426.666667s26.948267-139.8272 80.093867-192.9728S437.0944 153.6 512 153.6c74.922667 0 139.8272 26.948267 192.9728 80.093867C758.1184 286.839467 785.066667 351.761067 785.066667 426.666667s-26.948267 139.8272-80.093867 192.9728C651.8272 672.785067 586.922667 699.733333 512 699.733333z m0-512c-66.4576 0-121.668267 22.920533-168.840533 70.0928S273.066667 360.209067 273.066667 426.666667s22.920533 121.668267 70.0928 168.840533S445.5424 665.6 512 665.6s121.685333-22.9376 168.840533-70.0928C727.995733 548.352 750.933333 493.124267 750.933333 426.666667s-22.9376-121.668267-70.0928-168.840534S578.4576 187.733333 512 187.733333z" p-id="56578"></path></svg>,
//     "Contacts": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M895.2 1020H117.6c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h777.6c8.8 0 16 7.2 16 16v984c0 8.8-7.2 16-16 16z m-761.6-32h745.6V36H133.6v952zM506.4 713.6c-1.6 0-4-0.8-5.6-2.4-8.8-8-209.6-198.4-209.6-278.4 0-67.2 54.4-121.6 121.6-121.6 36 0 70.4 16 93.6 43.2 23.2-27.2 56.8-43.2 93.6-43.2 67.2 0 121.6 54.4 121.6 121.6 0 79.2-200.8 270.4-209.6 278.4-1.6 1.6-3.2 2.4-5.6 2.4zM413.6 326.4c-58.4 0-105.6 47.2-105.6 105.6 0 59.2 138.4 204 199.2 261.6 60-57.6 199.2-203.2 199.2-261.6 0-58.4-47.2-105.6-105.6-105.6-34.4 0-67.2 16.8-86.4 44.8-3.2 4-10.4 4-12.8 0-21.6-28-53.6-44.8-88-44.8zM1004 243.2h-108.8c-8.8 0-16-7.2-16-16V93.6c0-8.8 7.2-16 16-16h108.8c8.8 0 16 7.2 16 16v132.8c0 9.6-7.2 16.8-16 16.8z m-92.8-32h76.8V109.6h-76.8v101.6zM1004 477.6h-108.8c-8.8 0-16-7.2-16-16V328c0-8.8 7.2-16 16-16h108.8c8.8 0 16 7.2 16 16v132.8c0 9.6-7.2 16.8-16 16.8z m-92.8-32h76.8V344h-76.8v101.6zM1004 712h-108.8c-8.8 0-16-7.2-16-16V562.4c0-8.8 7.2-16 16-16h108.8c8.8 0 16 7.2 16 16V696c0 8.8-7.2 16-16 16z m-92.8-32h76.8V578.4h-76.8V680zM1004 946.4h-108.8c-8.8 0-16-7.2-16-16V796.8c0-8.8 7.2-16 16-16h108.8c8.8 0 16 7.2 16 16v132.8c0 9.6-7.2 16.8-16 16.8z m-92.8-32h76.8v-100.8h-76.8v100.8zM212.8 146.4H20c-8.8 0-16-7.2-16-16s7.2-16 16-16h192.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM212.8 272H20c-8.8 0-16-7.2-16-16s7.2-16 16-16h192.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM212.8 784H20c-8.8 0-16-7.2-16-16s7.2-16 16-16h192.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM212.8 909.6H20c-8.8 0-16-7.2-16-16s7.2-16 16-16h192.8c8.8 0 16 7.2 16 16s-7.2 16-16 16z" p-id="8223"></path></svg>,
//     "Notification": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M514.133333 938.666667H512c-81.066667 0-151.466667-61.866667-168.533333-145.066667-2.133333-10.666667 4.266667-23.466667 17.066666-25.6 10.666667-2.133333 23.466667 4.266667 25.6 17.066667 12.8 64 66.133333 110.933333 125.866667 110.933333h4.266667c59.733333 0 113.066667-46.933333 125.866666-110.933333 2.133333-10.666667 12.8-19.2 25.6-17.066667 10.666667 2.133333 19.2 12.8 17.066667 25.6-19.2 83.2-89.6 145.066667-170.666667 145.066667zM834.133333 810.666667H189.866667C155.733333 810.666667 128 782.933333 128 748.8c0-4.266667 0-6.4 2.133333-8.533333l78.933334-155.733334V366.933333C209.066667 211.2 334.933333 85.333333 492.8 85.333333H533.333333c155.733333 0 283.733333 125.866667 283.733334 281.6v215.466667l78.933333 155.733333v10.666667c0 34.133333-27.733333 61.866667-61.866667 61.866667zM170.666667 753.066667c2.133333 8.533333 10.666667 14.933333 19.2 14.933333h644.266666c8.533333 0 17.066667-6.4 19.2-14.933333L774.4 597.333333c-2.133333-2.133333-2.133333-6.4-2.133333-8.533333V366.933333C772.266667 234.666667 665.6 128 531.2 128H490.666667c-132.266667 0-241.066667 106.666667-241.066667 238.933333v221.866667c0 4.266667 0 6.4-2.133333 8.533333L170.666667 753.066667z" p-id="5487"></path></svg>,
//     "Alternative Links": <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M546.9184 665.4976a187.9552 187.9552 0 0 1-133.3248-55.1424 25.6 25.6 0 0 1 36.1984-36.1984 137.472 137.472 0 0 0 194.2016 0l186.1632-186.1632c53.5552-53.5552 53.5552-140.6464 0-194.2016s-140.6464-53.5552-194.2016 0L478.8736 350.8736a25.6 25.6 0 0 1-36.1984-36.1984l157.0816-157.0816c73.5232-73.5232 193.1264-73.5232 266.5984 0s73.5232 193.1264 0 266.5984l-186.1632 186.1632a187.9552 187.9552 0 0 1-133.3248 55.1424z" fill="" p-id="4784"></path><path d="M239.7184 972.6976a187.9552 187.9552 0 0 1-133.3248-55.1424 188.672 188.672 0 0 1 0-266.5984l186.1632-186.1632a188.672 188.672 0 0 1 266.5984 0 25.6 25.6 0 0 1-36.1984 36.1984 137.472 137.472 0 0 0-194.2016 0l-186.1632 186.1632c-53.5552 53.5552-53.5552 140.6464 0 194.2016s140.6464 53.5552 194.2016 0l157.0816-157.0816a25.6 25.6 0 0 1 36.1984 36.1984l-157.0816 157.0816a187.9552 187.9552 0 0 1-133.3248 55.1424z" fill="" p-id="4785"></path></svg>,
//     'Schedules': <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M826.368 482.304H197.12c-55.808 0-101.376-45.568-101.376-101.376s45.568-101.376 101.376-101.376h508.928c12.288 59.392 65.024 104.448 128 104.448 72.192 0 131.072-58.88 131.072-131.072S906.752 122.88 834.56 122.88c-62.976 0-115.712 45.056-128 104.448H197.12c-84.992 0-154.112 69.12-154.112 154.112s69.12 154.112 154.112 154.112h628.736c55.808 0 101.376 45.568 101.376 101.376s-45.568 101.376-101.376 101.376H325.632c-12.288-59.392-65.024-104.448-128-104.448-72.192 0-131.072 58.88-131.072 131.072S125.44 896 197.632 896c62.976 0 115.712-45.056 128-104.448h500.736c84.992 0 154.112-69.12 154.112-154.112 0-85.504-69.12-155.136-154.112-155.136z m8.192-306.176c43.008 0 77.824 34.816 77.824 77.824s-34.816 77.824-77.824 77.824-77.824-34.816-77.824-77.824 34.816-77.824 77.824-77.824zM197.12 842.24c-43.008 0-77.824-34.816-77.824-77.824s34.816-77.824 77.824-77.824 77.824 34.816 77.824 77.824-34.816 77.824-77.824 77.824z" p-id="34234"></path></svg>,
//     'Openings': <svg className='Ieditcomp_iconcss' viewBox={vb_} version={v_} xmlns={x_}><path d="M938.787758 82.0886 83.164606 82.0886c-10.286274 0-18.633383 8.493441-18.633383 18.974144 0 10.479679 8.348132 18.97312 18.633383 18.97312l45.233204 0c-6.721075 11.56029-10.595312 25.047466-10.595312 39.448454l0 705.016015c0 42.676985 33.92567 77.410044 75.618235 77.410044l179.545212 0c9.784854 0 17.890462-7.686053 18.584264-17.61724 10.17371-144.535861-40.966017-302.798351-173.116803-371.230929 140.870378-35.765575 243.519246-161.296593 284.22739-302.909891 16.35755 60.47228 43.436278 117.116371 79.446423 164.429956 40.400129 53.060473 107.026572 114.323768 208.156854 136.220475-104.862279 46.553269-175.668928 130.970914-166.981059 372.82831 0.37146 10.205433 8.606005 18.279319 18.634406 18.279319L819.958372 941.910377c41.902342 0 76.006068-34.733059 76.006068-77.410044L895.96444 159.484318c0-14.400988-3.895727-27.888164-10.650571-39.448454l53.473889 0c10.286274 0 18.633383-8.493441 18.633383-18.97312C957.42114 90.582041 949.074032 82.0886 938.787758 82.0886zM355.283214 903.963113 193.419709 903.963113c-20.782326 0-38.350446-18.068518-38.350446-39.46278L155.069263 568.402591C300.526099 611.113345 359.933117 762.155387 355.283214 903.963113zM155.069263 524.707416 155.069263 159.484318c0-21.378913 17.568121-39.448454 38.350446-39.448454l291.26876 0C482.783073 310.592874 351.633081 512.645706 155.069263 524.707416zM858.696652 864.500333c0 21.766746-17.374716 39.46278-38.737256 39.46278L660.01766 903.963113c-4.892427-243.084341 74.826196-298.711266 198.677968-338.354148L858.695628 864.500333zM858.696652 159.484318l0 361.508497c-125.288494-3.938706-203.345268-72.16253-247.121284-129.647779-56.160067-73.761957-88.681762-172.421978-89.586364-271.309172L819.958372 120.035864C841.321936 120.035864 858.696652 137.732921 858.696652 159.484318z" p-id="4199"></path></svg>
// }

const TYPE_ICON_MAP = {
    "Names": iconwrapper(NAMES_ICON, myiconcss),
    "Name": NAMEUSERS_SMALL,
    "Main Images": iconwrapper(IMAGES_ICON, myiconcss),
    "Fonts": iconwrapper(FONTS_ICON, myiconcss),
    "Description": iconwrapper(DESCRIP_ICON, myiconcss),
    "Our Journey": iconwrapper(DESCRIP_ICON, myiconcss),
    "Location": iconwrapper(LOC_ICON, myiconcss),
    "Date Time": iconwrapper(DATETIME_ICON, myiconcss),
    "Q&A": iconwrapper(QA_ICON, myiconcss),
    'Share': iconwrapper(SOCIALMEDIATHICK_ICON, myiconcss),
    "Content Examples": CONTENTEXAMPLE_SMALL,
    "Title": TITLE_SMALL,
    "Subtext": SUBTEXT_SMALL,
    "Baby Name": BABY_SMALL,
    'How We Met': iconwrapper(HOWWEMET_ICON, myiconcss),
    'Proposal': iconwrapper(PROPOSAL_ICON, myiconcss),
    'Promote': iconwrapper(PROMOTE_ICON, myiconcss),
    "Contacts": iconwrapper(CONTACT_ICON, myiconcss),
    "Notification": iconwrapper(NOTI_ICON, myiconcss),
    "Alternative Links": iconwrapper(LINK_ICON, myiconcss),
    'Schedules': iconwrapper(SCHEDULES_ICON, myiconcss),
    'Openings': iconwrapper(OPENING_ICON, myiconcss),
    'Registry': iconwrapper(REGISTRY_ICON, myiconcss),
    'Party': iconwrapper(PARTY_ICON, myiconcss),
    'Sequence': iconwrapper(SEQUENCE_ICON, myiconcss),
}

const Addnewentry = ({ ref, txt, onClick }) => {
    return <button ref={ref} className="Ieditcontact_addbtn" onClick={onClick} >
        {iconwrapper(ADD_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center', })}
        <div className='Ieditcontact_addtxt'>{txt}</div>
    </button>
}

const Twoinputs = (arr, i, placeholder1, placeholder2, onChange1, onChange2, onRemove, onDrag) => {
    return <div className="Iedit_twoinputstopdown" key={i + 'qna'} >
        <button
            onClick={onRemove}
            style={{ backgroundColor: 'transparent', border: 'none', width: 'max-content', display: 'flex', placeContent: 'center', alignItems: 'center', margin: 5, padding: 0 }}
        >
            {iconwrapper(CROSS_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center', color: 'var(--mainpink)' })}
        </button>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <input
                className="Iedit_input Iedit_topinput"
                value={arr[i]}
                onChange={onChange1}
                placeholder={placeholder1}
            />
            <input
                className="Iedit_input Iedit_btminput"
                value={arr[i + 1]}
                onChange={onChange2}
                placeholder={placeholder2}
            />
        </div>
    </div>
}

function Details(props) {

    const { partialwt, subpageexit, updateSubpageexit, updateSubpageback, save, clearBackup, restoreBackup, updateBackup, updateSelectedsubpage } = props

    const device = Checkdevice()
    const [firsttime, setFirsttime] = useState(true)
    const [itype, setItype] = useState(EMPTY)
    const [selectedsubpage, setSelectedsubpage] = useState(EMPTY)
    const [primaryfamilies, setPrimaryfamilies] = useState([])
    const [secfamilies, setSecfamilies] = useState([])
    const [lang, setLang] = useState('English')

    // question
    const [qndata, setQndata] = useState([])

    // registry
    const [registrydata, setRegistrydata] = useState([])

    // party
    const [partydata, setPartydata] = useState([])
    const [partyproperties, setPartyproperties] = useState({})

    // promote
    const [promotedata, setPromotedata] = useState([])

    const [allaltlinks_doms, setAllaltlinkdoms] = useState([]) // alternative links
    const [nameformat, setNameformat] = useState(-1) // 0: Web | 1: Tablet | 2: Mobile
    const [bs, setBs] = useState(false) // detect backspace is cllicked for input/textarea_dom
    const [fonttier, setFonttier] = useState(-1) // 0: primary font, 1: secondary font 

    // btmbar 
    const [showsave, setShowsave] = useState(false) // indicate save activate, when user make any savable actions.
    const commoneditstyle = {
        height: {
            'WEB': 'calc(100% - 70px - 65px)',
            'TABLET': 'calc(100% - 70px - 65px)',
            'MOBILE': 'calc(100% - 70px)'
        }[device],
        marginBottom: {
            'MOBILE': 65
        }[device]
    }

    useEffect(() => {
        if (firsttime) {
            var localfontfamilies = LANG_FF_MAP[lang]

            var primaryfamilies = []
            for (let i = 0; i < localfontfamilies.length; i++) {
                primaryfamilies.push(localfontfamilies[i])
            }

            var secfamilies = []
            for (let i = 0; i < localfontfamilies.length; i++) {
                secfamilies.push(localfontfamilies[i])
            }

            setPrimaryfamilies(primaryfamilies)
            setSecfamilies(secfamilies)
            setFirsttime(false)
        }
    }, [])

    useEffect(() => {
        var english = /^[A-Za-z0-9]*$/;
        if (english.test(props.testingword.split('')[0])) setLang('English')
        else setLang('Mandarin')
    }, [props.testingword])

    useEffect(() => {
        if (props.itype) setItype(props.itype)
    }, [props.itype])

    useEffect(() => { // question answer
        if (props.qnas.length > 0) {
            var qndata = []
            for (let i = 0; i < props.qnas.length; i = i + 2) {
                qndata.push({ qn: props.qnas[i], ans: props.qnas[i + 1] })
            }
            setQndata(qndata)
        }
        else {
            setQndata([])
        }
    }, [props.qnas])

    useEffect(() => { // question answer
        if (props.registry.length > 0) {
            var registrydata = []
            for (let i = 0; i < props.registry.length; i = i + 2) {
                registrydata.push({ title: props.registry[i], url: props.registry[i + 1] })
            }
            setRegistrydata(registrydata)
        }
        else {
            setRegistrydata([])
        }
    }, [props.registry])

    useEffect(() => { // question answer
        if (props.party.length > 0) {
            const new_party = JSON.parse(JSON.stringify(props.party))
            setPartydata(new_party)
        }
        else {
            setPartydata([])
        }
    }, [props.party])


    useEffect(() => {
        if (props.partyproperties && Object.keys(props.partyproperties).length > 0) {
            setPartyproperties(JSON.parse(JSON.stringify(props.partyproperties)))
        }
        else {
            setPartyproperties({})
        }
    }, [props.partyproperties])

    useEffect(() => { // promote
        if (props.promote) {
            var promotedata = []
            for (let i = 0; i < props.promote.length; i = i + 3) {
                var currobj = {
                    'vendorname': props.promote[i],
                    'link': props.promote[i + 1],
                    'vendortype': props.promote[i + 2],
                }
                promotedata.push(currobj)
            }
            setPromotedata(promotedata)
        }
    }, [props.promote])

    useEffect(() => { // INACTIVE
        var allaltlinks_doms = []
        const placeholder1 = 'Alternative link title.'
        const placeholder2 = 'Underlying alternative url.'
        if (props.alticlinks) {
            for (let i = 0; i < props.alticlinks.length; i = i + 2) {
                allaltlinks_doms.push(
                    Twoinputs(
                        props.alticlinks,
                        i,
                        placeholder1, placeholder2,
                        (event) => {
                            var local_alticlinks = props.alticlinks.slice()
                            local_alticlinks[i] = event.target.value
                            props.updateAlticlinks(local_alticlinks)
                        },
                        (event) => {
                            var local_alticlinks = props.alticlinks.slice()
                            local_alticlinks[i + 1] = event.target.value
                            props.updateAlticlinks(local_alticlinks)
                        },
                        () => {
                            var local_alticlinks = props.alticlinks.slice()
                            local_alticlinks.splice(i, 1)
                            local_alticlinks.splice(i, 1)
                            props.updateAlticlinks(local_alticlinks)
                        }
                    )
                )
            }
            setAllaltlinkdoms(allaltlinks_doms)
        }
    }, [props.alticlinks])

    useEffect(() => {
        setSelectedsubpage(props.selectedsubpage)
    }, [props.selectedsubpage])

    useEffect(() => {
        if (subpageexit) { // triggered if user click exit from Highlighttitle and tick yes for saveprompt
            setShowsave(false)
            restoreBackup()
            updateSelectedsubpage('')
            updateSubpageexit()
        }
    }, [subpageexit])

    const updateDetailcss = (key, item) => {
        var newobj = { ...props.css_map };
        newobj[key] = { 'textAlign': item };
        props.updateCss_map(newobj);
    }

    const updateLoccss = (key, value) => {
        var newobj = { ...props.css_map };
        newobj[key] = { 'textAlign': value };
        props.updateCss_map(newobj);
    }

    const revert = () => {
        restoreBackup()
        setShowsave(false)
    }

    const btmbar = <div
        className='iedit_swaproot'
        style={{
            'MOBILE': { position: 'fixed', bottom: 0, left: 0, width: '100%' },
            'TABLET': { position: 'fixed', bottom: 10, left: 0, width: (props.wt * 0.45) - 1 },
            'WEB': { position: 'fixed', bottom: 0, left: 0, width: (props.wt * 0.45) - 1 }
        }[device]}
    >
        <button
            className='iedit_cancel'
            disabled={!showsave}
            style={{ opacity: !showsave ? 0.5 : 1 }}
            onClick={revert}>
            Revert
        </button>
        <button
            className='iedit_save'
            style={{ opacity: !showsave ? 0.5 : 1 }}
            disabled={!showsave}
            onClick={() => {
                save().then((message) => {
                    if (message === 'SUCCESS') {
                        clearBackup();
                        setShowsave(false)
                    }
                    else {
                        setShowsave(true)
                    }
                })
            }}
        >
            Save
        </button>
    </div>

    // NAMES START
    var YOURNAME_DIV = (
        <div className="Details_grp">
            {input_dom(
                'Your Name',
                'Name',
                props.name,
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 50) { props.updateName(e.target.value); }
                },
                'name_id',
                {},
                false,
                null,
                {},
                input_css
            )}
        </div>
    )

    var SPOUSENAME_DIV = (
        <div className="Details_grp">
            {input_dom(
                `Spouse's Name`,
                `Spouse's Name`,
                props.spousename, (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 50) { props.updateSpousename(e.target.value) }
                },
                'spousename_id',
                {},
                false,
                null,
                {},
                input_css
            )}
        </div>
    )

    const ANIMATION_DIV = (
        <div className="Details_grp" style={{ padding: '0px 10px' }}>
            {partialtitle_dom('Text ( Mobile Only )', {})}
            {textarea_dom(
                '',
                'Join us in witnessing the union of',
                props.nameanimationdatatxt,
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    const { value } = e.target
                    if (!bs && value.length > 0 && value.length % 25 === 0) {
                        let result = e.target.value
                        let newstr = result + '\n'
                        props.updateNameanimationtext(newstr)
                    }
                    else {
                        props.updateNameanimationtext(e.target.value)
                    }
                },
                'animationdatatxt_id',
                {},
                false,
                null,
                {},
                txtarea_css,
                2,
                (e) => { setBs(e.key === 'Backspace' ? true : false) }
            )}
        </div>
    )

    const ANIMATIONDURATION_DIV = (
        <div className="Details_grp" style={{ padding: '0px 10px', marginBottom: 10 }}>
            {partialtitle_dom('Duration ( Mobile Only )', {})}
            {inputdescribe_dom('Duration of the text appear.')}
            <div style={{ height: 5 }} />
            {multiplechoice_dom(
                '',
                ['1s', '2s', '3s', '4s', '5s', '6s', '7s', '8s'],
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    props.updateNameanimationtimer(secondmap[e.target.value])
                },
                'animationduration_dom',
                {},
                inversesecondmap[props.nameanimationdatatimer],
                null,
                null,
                select_css
            )}
        </div>
    )

    const nameformatclicked = (e) => {
        var val = parseInt(e.target.value, 10)
        val === nameformat ? setNameformat(-1) : setNameformat(val)
    }

    const linerupdateWeb = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true); }
        props.updateNtw(parseInt(e.target.value))
    }
    const linerupdateTablet = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true); }
        props.updateNtt(parseInt(e.target.value))
    }
    const linerupdateMobile = (e) => {
        if (!showsave) { updateBackup(); setShowsave(true); }
        props.updateNtm(parseInt(e.target.value))
    }

    var WEDDINGNAMES_DIV = ( // combined of Yourname and Spousename
        <div className='Ieditcomp_div' style={commoneditstyle}>
            {YOURNAME_DIV}
            {SPOUSENAME_DIV}
            {props.name && props.spousename && props.name.length > 0 && props.spousename.length > 0
                ? <div className='Details_grp'>
                    {partialtitle_dom('Device Specific Settings', {})}
                    {inputdescribe_dom('Assign name formatting based on different devices.')}
                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}>
                        <button
                            key={'titlebtn_0'}
                            className={`Details_settingbtn ${nameformat === 0 ? 'Details_selectedbtn' : nameformat !== -1 ? 'Details_selectednone' : ''}`}
                            value={0}
                            onClick={nameformatclicked}
                        >
                            {iconwrapper(LAPTOP_ICON, { width: 27, height: 27, })}
                            <div>Desktop</div>
                        </button>
                        <button
                            key={'titlebtn_1'}
                            className={`Details_settingbtn ${nameformat === 1 ? 'Details_selectedbtn' : nameformat !== -1 ? 'Details_selectednone' : ''}`}
                            value={1}
                            onClick={nameformatclicked}
                        >
                            {iconwrapper(TABLET_ICON, { width: 27, height: 27, })}
                            <div>Tablet</div>
                        </button>
                        <button
                            key={'titlebtn_2'}
                            className={`Details_settingbtn ${nameformat === 2 ? 'Details_selectedbtn' : nameformat !== -1 ? 'Details_selectednone' : ''}`}
                            value={2}
                            onClick={nameformatclicked}
                        >
                            {iconwrapper(MOBILE_ICON, { width: 27, height: 27, })}
                            <div>Mobile</div>
                        </button>
                    </div>
                    {[
                        <div className='Details_lineacontainer'>
                            {partialtitle_dom('Formatting', { margin: '10px 10px 0px 10px' })}
                            {inputdescribe_dom(`Number of line to display your name and your spouse's name.`, { marginLeft: 10 })}
                            <div className='Details_linercol'>
                                <button className={`Details_linerroot ${props.ntw === 0 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 0px 10px', borderBottom: 'none', borderRadius: 5, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }} value={0} onClick={linerupdateWeb}>Three Liner</button>
                                <button className={`Details_linerroot ${props.ntw === 1 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 0px 10px', }} value={1} onClick={linerupdateWeb}>Two Liner</button>
                                <button className={`Details_linerroot ${props.ntw === 2 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 10px 10px', borderTop: 'none', borderRadius: 5, borderTopLeftRadius: 0, borderTopRightRadius: 0 }} value={2} onClick={linerupdateWeb}>One Liner</button>
                            </div>
                        </div>,

                        <div className='Details_lineacontainer'>
                            {partialtitle_dom('Formatting', { margin: '10px 10px 0px 10px' })}
                            {inputdescribe_dom(`Number of line to display your name and your spouse's name.`, { marginLeft: 10 })}
                            <div className='Details_linercol'>
                                <button className={`Details_linerroot ${props.ntt === 0 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 0px 10px', borderBottom: 'none', borderRadius: 5, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }} value={0} onClick={linerupdateTablet}>Three Liner</button>
                                <button className={`Details_linerroot ${props.ntt === 1 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 0px 10px', }} value={1} onClick={linerupdateTablet}>Two Liner</button>
                                <button className={`Details_linerroot ${props.ntt === 2 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 10px 10px', borderTop: 'none', borderRadius: 5, borderTopLeftRadius: 0, borderTopRightRadius: 0 }} value={2} onClick={linerupdateTablet}>One Liner</button>
                            </div>
                        </div>,

                        <div className='Details_lineacontainer'>
                            <div className='Details_grp'>
                                {partialtitle_dom('Formatting', { margin: '10px 10px 0px 10px' })}
                                {inputdescribe_dom(`Number of line to display your name and your spouse's name.`, { marginLeft: 10 })}
                                <div className='Details_linercol'>
                                    <button className={`Details_linerroot ${props.ntm === 0 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 0px 10px', borderBottom: 'none', borderRadius: 5, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }} value={0} onClick={linerupdateMobile}>Three Liner</button>
                                    <button className={`Details_linerroot ${props.ntm === 1 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 0px 10px', }} value={1} onClick={linerupdateMobile}>Two Liner</button>
                                    <button className={`Details_linerroot ${props.ntm === 2 ? 'Details_linerselected' : ''}`} style={{ margin: '0px 10px 0px 10px', borderTop: 'none', borderRadius: 5, borderTopLeftRadius: 0, borderTopRightRadius: 0 }} value={2} onClick={linerupdateMobile}>One Liner</button>
                                </div>
                            </div>
                            {props.templatetype === 1
                                ? <div className='Details_grp'>
                                    {partialtitle_dom('Text Animation', { margin: '0px 10px 0px 10px' })}
                                    {inputdescribe_dom(`Enable/Disable animation for specific device.`, { marginLeft: 10 })}
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        {radiobtn_dom(
                                            props.nam === 0,
                                            (e) => {
                                                if (!showsave) { updateBackup(); setShowsave(true); }
                                                props.updateNam(props.nam === 0 ? 1 : 0);
                                            },
                                            props.nam === 1 ? `"Text Animation" Enabled` : `"Text Animation" Disabled`,
                                            { marginLeft: 10 }
                                        )}
                                    </div>
                                </div>
                                : null}

                            {props.templatetype === 1 && props.nam === 0 ? ANIMATION_DIV : null}
                            {props.templatetype === 1 && props.nam === 0 ? ANIMATIONDURATION_DIV : null}

                        </div>
                    ][nameformat]}
                </div>
                : null}
            {btmbar}
        </div>
    )// NAMES END

    // FONT START
    var FONTS_DIV = (
        <div className='Ieditcomp_div' style={commoneditstyle}>
            <div className='Detailsfont_root'>

                <div className='Details_grp'>
                    {partialtitle_dom('Font Color', {})}
                    {inputdescribe_dom(`Assign color to font you are using for your website, click reset to revert back to default`)}
                    <div className='Detailsfont_container'>
                        <div className='Detailsfont_left'>
                            <HexColorPicker
                                style={{ height: 200, width: 200 }}
                                color={props.fc}
                                onChange={(c) => { if (!showsave) { updateBackup(); setShowsave(true); } props.updateFc(c); }} />
                            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, alignItems: 'center' }}>
                                <div style={{ paddingRight: 3, fontSize: 18 }}>#</div>
                                <HexColorInput
                                    color={props.fc}
                                    onChange={(c) => {
                                        if (!showsave) {
                                            updateBackup();
                                            setShowsave(true);
                                        }
                                        props.updateFc(c);
                                    }}
                                    style={{ width: '100%', borderRadius: 8, padding: '3px 5px', border: '1px solid var(--maindark)' }}
                                />
                            </div>
                        </div>
                        <ul className='Detailsfont_right'>
                            {colors_arr.map((c, i) => {
                                return <div key={i + 'color1'} style={{ padding: 1, width: 'max-content', height: 'max-content', display: 'flex', placeContent: 'center', alignItems: 'center', border: props.fc === c ? '2px solid var(--mainpink)' : '2px solid transparent', borderRadius: 5 }}>
                                    <li style={{ width: 20, height: 20, backgroundColor: c, border: 'none', cursor: 'pointer', borderRadius: 3, border: props.fc === c ? 'none' : '1px solid #dddddd' }} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } props.updateFc(c); }} />
                                </div>
                            })}
                        </ul>
                    </div>
                </div>

                <div className='Details_grp'>
                    {partialtitle_dom('Primary Font', {})}
                    {inputdescribe_dom('Dominant font that is use mostly throughout your RSVP website', { marginBottom: 5 })}
                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 15 }}>
                        <li className='Detailsfont_li' style={{ fontFamily: props.priff, borderRadius: 10, boxShadow: '0 1px 2px 0 rgb(60 64 67 / 30%), 0 2px 6px 2px rgb(60 64 67 / 15%)', border: 'none', padding: '5px 0px', overflow: 'hidden' }} >
                            <div className='Detailsfont_toprightff'>{props.priff}</div>
                            <div className='Detailsfont_actualtxt' style={{ width: '100%', fontFamily: props.priff, padding: '0px 10px' }}>{props.name.length > 0 && props.spousename.length > 0 ? props.name + ' & ' + props.spousename : 'Your Name & Spouse Name'}</div>
                            {fonttier === 0 ? null : <button className='Detailsfont_fontslen' onClick={() => { setFonttier(fonttier === 0 ? -1 : 0) }}>Expand</button>}
                        </li>
                        <div className='Detailsfont_arrowsroot'>
                            <button
                                className='Detailsfont_arrowleft'
                                onClick={() => {
                                    if (!showsave) { updateBackup(); setShowsave(true); }
                                    const index = primaryfamilies.indexOf(props.priff)
                                    index === 0 ? props.updatePriff(primaryfamilies[primaryfamilies.length - 1]) : props.updatePriff(primaryfamilies[index - 1])
                                }}
                            >
                                {ARROWLEFT_SMALL}
                            </button>
                            <div style={{ fontSize: 12, height: 35, width: 70, display: 'flex', placeContent: 'center', textAlign: 'center', alignItems: 'center' }}>{props.priff}</div>
                            <button
                                className='Detailsfont_arrowright'
                                onClick={() => {
                                    if (!showsave) { updateBackup(); setShowsave(true); }
                                    const index = primaryfamilies.indexOf(props.priff)
                                    index === primaryfamilies.length - 1 ? props.updatePriff(primaryfamilies[0]) : props.updatePriff(primaryfamilies[index + 1])
                                }}
                            >
                                {ARROWRIGHT_SMALL}
                            </button>
                        </div>
                    </div>

                    {fonttier === 0
                        ? <button className='Detailsfont_closebtn' style={fonttier === 1 ? { border: 'none' } : { color: 'var(--maindark)' }} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } setFonttier(fonttier === 0 ? -1 : 0); }}> {CLOSE_ICON}</button>
                        : null}

                    {fonttier === 0
                        ? [primaryfamilies, secfamilies][fonttier].map((ff, i) => {
                            return <li
                                key={ff + '_' + i + 'ft0'}
                                className={`Detailsfont_li ${(fonttier === 0 && props.priff === ff) || (fonttier === 1 && props.secff === ff) ? 'Detailsfont_liselected' : ''}`}
                                style={{ borderRadius: (i === 0) ? '10px 10px 0px 0px' : (i === primaryfamilies.length - 1) ? '0px 0px 10px 10px' : '0px', marginTop: i === 0 ? 10 : 0, marginBottom: i === primaryfamilies.length - 1 ? 10 : 0 }}
                                onClick={() => {
                                    if (!showsave) { updateBackup(); setShowsave(true); }

                                    if (fonttier === 0) {
                                        props.updatePriff(ff)
                                    }
                                    else if (fonttier === 1) {
                                        props.updateSecff(ff)
                                    }
                                }}
                            >
                                <div className='Detailsfont_toprightff'>{ff}</div>
                                <div className='Detailsfont_actualtxt' style={{ fontFamily: ff, }}>{props.name.length > 0 && props.spousename.length > 0 ? props.name + ' & ' + props.spousename : 'Your Name & Spouse Name'}</div>
                            </li>
                        })
                        : null}
                </div>

                <div className='Details_grp' >
                    {partialtitle_dom('Secondary Font', {})}
                    {inputdescribe_dom('Font that is use mainly to describe important things on your RSVP website. ', { marginBottom: 5 })}

                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 15 }}>
                        <li className='Detailsfont_li' style={{ fontFamily: props.secff, borderRadius: 10, boxShadow: '0 1px 2px 0 rgb(60 64 67 / 30%), 0 2px 6px 2px rgb(60 64 67 / 15%)', border: 'none', padding: '5px 0px', overflow: 'hidden' }} >
                            <div className='Detailsfont_toprightff'>{props.secff}</div>
                            <div className='Detailsfont_actualtxt' style={{ width: '100%', fontFamily: props.secff, padding: '0px 10px' }}>{props.name.length > 0 && props.spousename.length > 0 ? props.name + ' & ' + props.spousename : 'Your Name & Spouse Name'}</div>
                            {fonttier === 1 ? null : <button className='Detailsfont_fontslen' onClick={() => { setFonttier(fonttier === 1 ? -1 : 1); }}>Expand</button>}
                        </li>
                        <div className='Detailsfont_arrowsroot'>
                            <button
                                className='Detailsfont_arrowleft'
                                onClick={() => {
                                    if (!showsave) { updateBackup(); setShowsave(true); }
                                    const index = secfamilies.indexOf(props.secff)
                                    index === 0 ? props.updateSecff(secfamilies[secfamilies.length - 1]) : props.updateSecff(secfamilies[index - 1])
                                }}
                            >
                                {ARROWLEFT_SMALL}
                            </button>
                            <div style={{ fontSize: 12, height: 35, width: 70, display: 'flex', placeContent: 'center', textAlign: 'center', alignItems: 'center' }}>{props.secff}</div>
                            <button
                                className='Detailsfont_arrowright'
                                onClick={() => {
                                    if (!showsave) { updateBackup(); setShowsave(true); }
                                    const index = secfamilies.indexOf(props.secff)
                                    index === secfamilies.length - 1 ? props.updateSecff(secfamilies[0]) : props.updateSecff(secfamilies[index + 1])
                                }}
                            >
                                {ARROWRIGHT_SMALL}
                            </button>
                        </div>
                    </div>
                    {fonttier === 1
                        ? <button className='Detailsfont_closebtn' style={fonttier === 1 ? { border: 'none' } : { color: 'var(--maindark)' }} onClick={() => { setFonttier(fonttier === 1 ? -1 : 1) }}> {CLOSE_ICON}</button>
                        : null}
                    {fonttier === 1
                        ? [primaryfamilies, secfamilies][fonttier].map((ff, i) => {
                            return <li
                                key={ff + '_' + i + 'ft1'}
                                className={`Detailsfont_li ${(fonttier === 0 && props.priff === ff) || (fonttier === 1 && props.secff === ff) ? 'Detailsfont_liselected' : ''}`}
                                style={{ borderRadius: (i === 0) ? '10px 10px 0px 0px' : (i === primaryfamilies.length - 1) ? '0px 0px 10px 10px' : '0px', marginTop: i === 0 ? 10 : 0, marginBottom: i === primaryfamilies.length - 1 ? 10 : 0 }}
                                onClick={() => {
                                    if (!showsave) { updateBackup(); setShowsave(true); }
                                    if (fonttier === 0) {
                                        props.updatePriff(ff)
                                    }
                                    else if (fonttier === 1) {
                                        props.updateSecff(ff)
                                    }
                                }}
                            >
                                <div className='Detailsfont_toprightff'>{ff}</div>
                                <div className='Detailsfont_actualtxt' style={{ fontFamily: ff, }}>{props.name.length > 0 && props.spousename.length > 0 ? props.name + ' & ' + props.spousename : 'Your Name & Spouse Name'}</div>
                            </li>
                        })
                        : null}
                </div>

            </div>
            {btmbar}
        </div>
    )// FONT END



    // OUR JOURNEY START
    const { updateMaintext, maintext, updateProposal, updateHowwemet, howwemet = [], proposal = [] } = props
    const OURJOURNEY_DIV = <div className='Ieditcomp_div' style={commoneditstyle}>
        <div className='Details_grp'>
            {partialtitle_dom('Description', {})}
            {inputdescribe_dom('Introduction description for your website.')}
            <AlignmentSelector
                css_map={props.css_map}
                updateBackup={updateBackup}
                setShowsave={setShowsave}
                updateDetailcss={updateDetailcss}
                showsave={showsave}
                sectionKey="maintext"
                selectA='left'
                selectB='center'
                selectC='right'
            />
            {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', flexDirection: 'row', border: '1px solid var(--subgrey)',  borderRadius: 10, overflow: 'hidden', padding: 5, marginBottom:10 }}>
                    <div
                        className="ie_sm"
                        style={props.css_map['maintext']
                            ? props.css_map['maintext'].textAlign === 'left'
                                ? { backgroundColor: 'var(--maindark)', color: 'white', border: 'none', height: 30, width: 30, borderRadius:5 }
                                : { backgroundColor: 'transparent', color: '#707070', border: 'none', height: 30, width: 30 }
                            : null}
                        onClick={() => {
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            updateDetailcss('maintext', 'left')
                        }}>
                        {iconwrapper(TXTLEFT_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                    </div>
                    <div
                        className="ie_md"
                        style={props.css_map['maintext']
                            ? props.css_map['maintext'].textAlign === 'center'
                                ? { backgroundColor: 'var(--maindark)', color: 'white', border: 'none', height: 30, width: 30, borderRadius:5 }
                                : { backgroundColor: 'transparent', color: '#707070', border: 'none', height: 30, width: 30, }
                            : null}
                        onClick={() => {
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            updateDetailcss('maintext', 'center')
                        }}>
                        {iconwrapper(TXTCENTER_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                    </div>
                    <div
                        className="ie_lg"
                        style={props.css_map['maintext']
                            ? props.css_map['maintext'].textAlign === 'right'
                                ? { backgroundColor: 'var(--maindark)', color: 'white', border: 'none', height: 30, width: 30, borderRadius:5 }
                                : { backgroundColor: 'transparent', color: '#707070', border: 'none', height: 30, width: 30 }
                            : null}
                        onClick={() => {
                            if (!showsave) {
                                updateBackup(); setShowsave(true);
                            }
                            updateDetailcss('maintext', 'right')
                        }}>
                        {iconwrapper(TXTRIGHT_ICON, { width: 20, height: 20, display: 'flex', placeContent: 'center' })}
                    </div>
                </div>
            </div> */}
            <textarea
                rows="4"
                cols="50"
                name="comment"
                form="usrform"
                className='Details_txtarea'
                onChange={(event) => { if (!showsave) { updateBackup(); setShowsave(true); } if (event.target.value.length < 1000) { updateMaintext(event.target.value) } }}
                value={maintext}
            />
        </div>

        <div className='Details_grp'>
            {partialtitle_dom('How We Met?', {})}
            {inputdescribe_dom('Brief story on how you met your sigificant part.')}
            <AlignmentSelector
                css_map={props.css_map}
                updateBackup={updateBackup}
                setShowsave={setShowsave}
                updateDetailcss={updateDetailcss}
                showsave={showsave}
                sectionKey="howwemet"
                selectA='left'
                selectB='center'
                selectC='right'
            />
            {/* <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 15, placeContent: 'flex-end' }}>
                <div className="ie_sm" style={props.css_map['howwemet'] ? props.css_map['howwemet'].textAlign === 'left' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateDetailcss('howwemet', 'left') }}>{MOVELEFT}</div>
                <div className="ie_md" style={props.css_map['howwemet'] ? props.css_map['howwemet'].textAlign === 'center' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateDetailcss('howwemet', 'center') }}>{HORIZONTALMIDDLE}</div>
                <div className="ie_lg" style={props.css_map['howwemet'] ? props.css_map['howwemet'].textAlign === 'right' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateDetailcss('howwemet', 'right') }}>{MOVERIGHT}</div>
            </div> */}
            <textarea
                rows="4"
                cols="50"
                name="comment"
                form="usrform"
                className='Details_txtarea'
                onChange={(e) => { if (!showsave) { updateBackup(); setShowsave(true); } if (e.target.value.length < 1000) { updateHowwemet([howwemet[0], e.target.value]) } }}
                value={howwemet[1]}
            />
        </div>

        <div className='Details_grp'>
            {partialtitle_dom('Proposal', {})}
            {inputdescribe_dom('Brief story on how you propose?')}
            <AlignmentSelector
                css_map={props.css_map}
                updateBackup={updateBackup}
                setShowsave={setShowsave}
                updateDetailcss={updateDetailcss}
                showsave={showsave}
                sectionKey="proposal"
                selectA='left'
                selectB='center'
                selectC='right'
            />
            {/* <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 15, placeContent: 'flex-end' }}>
                <div className="ie_sm" style={props.css_map['proposal'] ? props.css_map['proposal'].textAlign === 'left' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateDetailcss('proposal', 'left') }}>{MOVELEFT}</div>
                <div className="ie_md" style={props.css_map['proposal'] ? props.css_map['proposal'].textAlign === 'center' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateDetailcss('proposal', 'center') }}>{HORIZONTALMIDDLE}</div>
                <div className="ie_lg" style={props.css_map['proposal'] ? props.css_map['proposal'].textAlign === 'right' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateDetailcss('proposal', 'right') }}>{MOVERIGHT}</div>
            </div> */}
            <textarea
                rows="4"
                cols="50"
                name="comment"
                form="usrform"
                className='Details_txtarea'
                onChange={(e) => { if (!showsave) { updateBackup(); setShowsave(true); } if (e.target.value.length < 1000) { updateProposal([proposal[0], e.target.value]) } }}
                value={proposal[1]}
            />
        </div>

        {btmbar}
    </div> // OUR JOURNEY END

    // MAIN IMAGES END

    // LOCATION START 
    var LOC_DIV_old = <div className='Ieditcomp_div' style={commoneditstyle}>
        <div className="Details_grp">
            {textarea_dom(
                'Location',
                'Some venue.',
                props.location,
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    var text = e.target.value
                    var nextline = /\r|\n/.exec(text); // check if text consist of single next line

                    if (e.target.value.length > 25 && !nextline) { // is more than a single allowable length and no next line
                        props.updateLocation('')
                    }
                    else if (e.target.value.length < 100) {
                        const { value } = e.target
                        if (!bs && value.length > 0 && value.length % 25 === 0) {
                            let result = e.target.value
                            let newstr = result + '\n'
                            props.updateLocation(newstr)
                        }
                        else {
                            props.updateLocation(e.target.value)
                        }
                    }

                },
                'details_locationvenue',
                {},
                false,
                null,
                {},
                txtarea_css,
                3,
                (e) => { setBs(e.key === 'Backspace' ? true : false) }
            )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <div className="Details_grp">
                {input_dom(
                    'Latitude',
                    '1.11232',
                    props.lat,
                    (event) => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        const val = event.target.value;
                        if (event.target.value.length < 20 && isFinite(val) && Math.abs(val) <= 90) {
                            props.updateLat(val)
                        }
                    },
                    'lat_id',
                    {},
                    false,
                    null,
                    {},
                    input_css)}
            </div>
            {EMPTYSPACE}
            <div className="Details_grp">
                {input_dom(
                    'Longitude',
                    '1.11232',
                    props.long,
                    (event) => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        const val = event.target.value; if (event.target.value.length < 20 && isFinite(val) && Math.abs(val) <= 900) props.updateLong(val)
                    },
                    'long_id',
                    {},
                    false,
                    null,
                    {},
                    input_css)}
            </div>
        </div>
        <div className="Details_grp">
            {input_dom(
                'Google Location URL',
                '',
                props.locurl,
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 400) { props.updateLocurl(e.target.value) }
                },
                'long_id',
                {},
                false,
                null,
                {},
                input_css)}
        </div>
        <div className="Details_grp">
            {partialtitle_dom('Description', {})}
            <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'end', marginBottom: 15 }}>
                <div className="ie_sm" style={props.css_map['locdescript'] ? props.css_map['locdescript'].textAlign === 'left' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateLoccss('locdescript', 'left') }}>{MOVELEFT}</div>
                <div className="ie_md" style={props.css_map['locdescript'] ? props.css_map['locdescript'].textAlign === 'center' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateLoccss('locdescript', 'center') }}>{HORIZONTALMIDDLE}</div>
                <div className="ie_lg" style={props.css_map['locdescript'] ? props.css_map['locdescript'].textAlign === 'right' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateLoccss('locdescript', 'right') }}>{MOVERIGHT}</div>
            </div>
            <textarea
                key={'location_description'}
                rows="4"
                cols="50"
                name="comment"
                form="usrform"
                placeholder={'Contact us if you are lost. Our number can be found in the navigation bar.'}
                className='Details_txtarea'
                value={props.location_map['locdescript']}
                onChange={(e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 149) {
                        props.updateLocdescript(e.target.value)
                    }
                }}
            />
        </div>
        <div className='Details_grp' >
            {partialtitle_dom('Location Font-family', { margin: 0 })}
            {inputdescribe_dom(`Font-family of navigation component.`, { margin: 0 })}
            {twobtn_dom(
                <>
                    <div style={{ pointerEvents: 'none', overflow: 'hidden', }} >Primary Font</div>
                    <div style={{ pointerEvents: 'none', overflow: 'hidden', fontSize: 12 }} >{` ( ${props.priff} ) `} </div>
                </>,
                <>
                    <div style={{ pointerEvents: 'none', overflow: 'hidden', }} >Secondary Font</div>
                    <div style={{ pointerEvents: 'none', overflow: 'hidden', fontSize: 12 }} >{` ( ${props.secff} ) `} </div>
                </>,
                'Primary Font', 'Secondary Font',
                props.locationff === props.priff ? 'Primary Font' : 'Secondary Font',
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    props.updateLocationfftier();
                },
                { height: 55 }
            )}
        </div>
        <div className='Details_grp' >
            {partialtitle_dom('Map Color', { margin: 0 })}
            {inputdescribe_dom(`Map to display your event venue.`, { margin: 0 })}
            {twobtn_dom(
                'Classic',
                'Dark',
                0,
                1,
                props.mapmode,
                (m) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    props.updateMapmode(m);
                },
                { height: 40 })}
        </div>
        {btmbar}
    </div>// LOCATION END

    var LOCATION_DIV = <div className='Ieditcomp_div' style={commoneditstyle}>

        <Explain title={'Location'} txt={'Update your wedding venue location here to assist your guests in easily finding their way to your event.'} />

        <div className="Details_grp">
            {textarea_dom(
                'Location',
                'Some venue.',
                props.location,
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    var text = e.target.value
                    var nextline = /\r|\n/.exec(text); // check if text consist of single next line

                    if (e.target.value.length > 25 && !nextline) { // is more than a single allowable length and no next line
                        props.updateLocation('')
                    }
                    else if (e.target.value.length < 100) {
                        const { value } = e.target
                        if (!bs && value.length > 0 && value.length % 25 === 0) {
                            let result = e.target.value
                            let newstr = result + '\n'
                            props.updateLocation(newstr)
                        }
                        else {
                            props.updateLocation(e.target.value)
                        }
                    }
                },
                'details_locationvenue',
                {},
                false,
                null,
                {},
                txtarea_css,
                3,
                (e) => { setBs(e.key === 'Backspace' ? true : false) }
            )}
        </div>

        <div className="Details_grp">
            {partialtitle_dom(`Map Type`, {})}
            {inputdescribe_dom(`Choose the type of map you want to use`, { margin: 0 })}
            {twobtn_dom(
                'Google',
                'Leaflet',
                'GOOGLE',
                'LEAFLET',
                props.location_map['maptype'],
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    props.updateLocationmap('maptype', e.target.value)
                },
                { height: 40, width: 100 }
            )}
        </div>

        <div className='Details_grp' >
            {partialtitle_dom('Location Font-family', { margin: 0 })}
            {inputdescribe_dom(`Font-family of navigation component.`, { margin: 0 })}
            {twobtn_dom(
                <>
                    <div style={{ pointerEvents: 'none', overflow: 'hidden', }} >Primary Font</div>
                    <div style={{ pointerEvents: 'none', overflow: 'hidden', fontSize: 12 }} >{` ( ${props.priff} ) `} </div>
                </>,
                <>
                    <div style={{ pointerEvents: 'none', overflow: 'hidden', }} >Secondary Font</div>
                    <div style={{ pointerEvents: 'none', overflow: 'hidden', fontSize: 12 }} >{` ( ${props.secff} ) `} </div>
                </>,
                'Primary Font',
                'Secondary Font',
                props.locationff === props.priff ? 'Primary Font' : 'Secondary Font',
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    props.updateLocationfftier();
                },
                { height: 55 }
            )}
        </div>

        <div className="Details_grp">
            {partialtitle_dom(`Map Description ( ${props.location_map['locdescript'].length ? props.location_map['locdescript'].length : 0}/300 )`, {})}
            <AlignmentSelector
                css_map={props.css_map}
                updateBackup={updateBackup}
                setShowsave={setShowsave}
                updateDetailcss={updateDetailcss}
                showsave={showsave}
                sectionKey="locdescript"
                selectA='start'
                selectB='center'
                selectC='end'
            />
            {/* <div style={{ display: 'flex', flexDirection: 'row', placeContent: 'flex-end', marginBottom: 15 }}>
                <div className="ie_sm" style={props.css_map['locdescript'] ? props.css_map['locdescript'].textAlign === 'start' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateLoccss('locdescript', 'start') }}>{MOVELEFT}</div>
                <div className="ie_md" style={props.css_map['locdescript'] ? props.css_map['locdescript'].textAlign === 'center' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateLoccss('locdescript', 'center') }}>{HORIZONTALMIDDLE}</div>
                <div className="ie_lg" style={props.css_map['locdescript'] ? props.css_map['locdescript'].textAlign === 'end' ? { backgroundColor: '#eb5d7b', color: 'white' } : { backgroundColor: 'white', color: '#707070' } : null} onClick={() => { if (!showsave) { updateBackup(); setShowsave(true); } updateLoccss('locdescript', 'end') }}>{MOVERIGHT}</div>
            </div> */}
            {textarea_dom(
                '',
                '',
                props.location_map['locdescript'],
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 301) { props.updateLocationmap('locdescript', e.target.value) }
                },
                'locationdescription_id',
                {},
                false,
                null,
                {},
                { ...txtarea_css, marginBottom: 15 },
                5,
                (e) => { setBs(e.key === 'Backspace' ? true : false) }
            )}
        </div>

        {props.location_map['maptype'] === 'GOOGLE'
            ? <div>
                {textarea_dom(
                    `Google Map Iframe`,
                    '',
                    props.location_map['googleiframesrc'],
                    (e) => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        if (e.target.value.length < 1001) { props.updateLocationmap('googleiframesrc', e.target.value) }
                    },
                    'googleiframesrc_id',
                    {},
                    false,
                    null,
                    {},
                    { ...txtarea_css, marginBottom: 15 },
                    5,
                    (e) => { setBs(e.key === 'Backspace' ? true : false) }
                )}
            </div>
            : null}


        {props.location_map['maptype'] === 'LEAFLET'
            ? <div style={{ display: 'flex', flexDirection: 'column' }}>

                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <div className="Details_grp">
                        {input_dom(
                            'Latitude',
                            '1.11232',
                            props.location_map['leafletlat'],
                            (event) => {
                                if (!showsave) { updateBackup(); setShowsave(true); }
                                const val = event.target.value;
                                if (event.target.value.length < 20 && isFinite(val) && Math.abs(val) <= 90) {
                                    props.updateLocationmap('leafletlat', val)
                                }
                            },
                            'lat_id',
                            {},
                            false,
                            null,
                            {},
                            input_css)}
                    </div>
                    {EMPTYSPACE}
                    <div className="Details_grp">
                        {input_dom(
                            'Longitude',
                            '1.11232',
                            props.location_map['leafletlong'],
                            (event) => {
                                if (!showsave) { updateBackup(); setShowsave(true); }
                                const val = event.target.value;
                                if (event.target.value.length < 20 && isFinite(val) && Math.abs(val) <= 900) {
                                    props.updateLocationmap('leafletlong', val)
                                }
                            },
                            'long_id',
                            {},
                            false,
                            null,
                            {},
                            input_css)}
                    </div>
                </div>

                <div className="Details_grp">
                    {input_dom(
                        'Google Location URL',
                        '',
                        props.location_map['leafletlocurl'],
                        (e) => {
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            if (e.target.value.length < 400) {
                                props.updateLocationmap('leafletlocurl', e.target.value)
                            }
                        },
                        'long_id',
                        {},
                        false,
                        null,
                        {},
                        input_css)}
                </div>

                <div className='Details_grp' >
                    {partialtitle_dom('Map Color', { margin: 0 })}
                    {inputdescribe_dom(`Map to display your event venue.`, { margin: 0 })}
                    {twobtn_dom(
                        'Classic',
                        'Dark',
                        0,
                        1,
                        props.location_map['leafletmapmode'],
                        (e) => {
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            props.updateLocationmap('leafletmapmode', parseInt(e.target.value))
                        },
                        { height: 40 })}
                </div>
            </div>
            : null}

        {btmbar}
    </div>

    // DATE START
    var DATE_DIV = ({ updateDate, itype, updateTime, time, dt_type, countdown, date_w, date_e, fc, bgc }) => {

        const left = () => {
            if (!showsave) { updateBackup(); setShowsave(true); }
            props.updateDatetype(parseInt(dt_type, 10) === 0 ? 3 : parseInt(dt_type, 10) - 1)
        }

        const right = () => {
            if (!showsave) { updateBackup(); setShowsave(true); }
            props.updateDatetype(parseInt(dt_type, 10) === 3 ? 0 : parseInt(dt_type, 10) + 1)
        }

        // stopped here, need to add count down time
        return <div className='Ieditcomp_div' style={commoneditstyle}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 15, height: 210, alignItems: 'center', border: '1px solid #e9e9e9' }}>
                <button onClick={left} className="Details_directionbtn">
                    <Icon size={20} icon={arrow_left} />
                </button>
                <Invdate
                    countdown={countdown}
                    date_e={date_e}
                    date_w={date_w}
                    itype={itype}
                    dt_type={dt_type}
                    time={time}
                    fc={'var(--maindark)'}
                    bgcolor={'#ffffff'}
                    device={device}
                    from={'Details'}
                    datetimeff={(e) => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        props.datetimeff(e)
                    }}
                />
                <button onClick={right} className="Details_directionbtn">
                    <Icon size={20} icon={arrow_right} />
                </button>
            </div>

            <div className='Details_grp' style={{ flexDirection: 'column', width: '50%' }}>
                {partialtitle_dom('When\'s the day?', {})}
                <Calendar
                    check={itype === 'Wedding' && props.date_w.toString().length > 0}
                    selected={itype === 'Wedding' ? props.date_w : props.date_e}
                    // updateDatew={(d) => { setDate_w(d); setEditedsignal(true) }}
                    onChange={(d) => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        itype === 'Wedding' ? props.updateDatew(d) : props.updateDatee(d)
                    }}
                    updateDate={() => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        updateDate('')
                    }}
                />
            </div>

            <div className='Details_grp' style={{ flexDirection: 'column', width: '100%' }}>
                {input_dom(
                    'Time of the event?',
                    '05:00 PM',
                    time,
                    (e) => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        if (e.target.value.length < 50) { updateTime(e.target.value) }
                    },
                    'timeid', {}, false, null, {}, inputhalf_css)}
            </div>

            <div className='Details_grp' >
                {partialtitle_dom('Countdown timer', { margin: 0 })}
                <div className='Details_notirow'>
                    <label className="Details_switch">
                        <input
                            type="checkbox"
                            checked={props.countdown}
                            onChange={() => {
                                if (!showsave) { updateBackup(); setShowsave(true); }
                                props.updateCountdowntimer(!props.countdown)
                            }}
                        />
                        <span className="Details_slider round" />
                    </label>
                    <div className='Details_notitxt'>
                        {props.countdown ? 'Countdown On' : 'Countdown Off'}
                    </div>
                </div>
            </div>

            <div className='Details_grp' >
                {partialtitle_dom('Date and Time Font-family', { margin: 0 })}
                {inputdescribe_dom(`Font-family for your location. Is advice to use a easily readable Font-family.`, { margin: 0 })}
                {twobtn_dom(
                    <>
                        <div style={{ pointerEvents: 'none', overflow: 'hidden', }} >Primary Font</div>
                        <div style={{ pointerEvents: 'none', overflow: 'hidden', fontSize: 12 }} >{` ( ${props.priff} ) `} </div>
                    </>,
                    <>
                        <div style={{ pointerEvents: 'none', overflow: 'hidden', }} >Secondary Font</div>
                        <div style={{ pointerEvents: 'none', overflow: 'hidden', fontSize: 12 }} >{` ( ${props.secff} ) `} </div>
                    </>,
                    'Primary Font', 'Secondary Font',
                    props.datetimeff === props.priff ? 'Primary Font' : 'Secondary Font',
                    (e) => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        props.updateDatetimefftier(e)
                    },
                    { height: 55 }
                )}
            </div>

            {btmbar}
        </div>
    }// DATE END

    // SHARE START
    var FB_DIV = ( // use in itype : House-Warming, Birthday Party,
        <div className="Details_grp">
            {input_dom(
                'Facebook Link',
                'https://www.facebook.com/cereweaveweddingevent',
                props.socialmedias[0],
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 1000) {
                        props.updateSm([e.target.value, props.socialmedias[1], props.socialmedias[2], props.socialmedias[3]])
                    }
                },
                'fb_id', {}, false, null, {}, input_css)}
        </div>
    )

    var INSTA_DIV = ( // use in itype : House-Warming, Birthday Party,


        <div className="Details_grp">
            {input_dom(
                'Instagram Link',
                `https://www.instagram.com/${STARTUP_NAME}/?hl=en`,
                props.socialmedias[1],
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 1000) {
                        props.updateSm([props.socialmedias[0], e.target.value, props.socialmedias[2], props.socialmedias[3]])
                    }
                },
                'insta_id', {}, false, null, {}, input_css)}
        </div>

    )

    var WHATSAPP_DIV = (
        <div className="Details_grp">
            {input_dom(
                'Whatsapp',
                'https://api.whatsapp.com/send?phone=65XXXXXXXX',
                props.socialmedias[2],
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 1000) {
                        props.updateSm([props.socialmedias[0], props.socialmedias[1], e.target.value, props.socialmedias[3]])
                    }
                },
                'whatsapp_id', {}, false, null, {}, input_css)}
        </div>

    )

    var TELEGRAM_DIV = (
        <div className="Details_grp">
            {input_dom(
                'Telegram',
                'https://t.me/joinchat/SODqlkA7FJ8Ecxyu4yNstw',
                props.socialmedias[3],
                (e) => {
                    if (!showsave) { updateBackup(); setShowsave(true); }
                    if (e.target.value.length < 1000) {
                        props.updateSm([props.socialmedias[0], props.socialmedias[1], props.socialmedias[2], e.target.value])
                    }
                },
                'telegram_id', {}, false, null, {}, input_css)}
        </div>
    )

    var SHARE_DIV = <div className='Ieditcomp_div' style={commoneditstyle}>
        <Explain title={'Share'} txt={'Sends your guest to your Facebook page, Instagram page or contact you through Whatsapp.'} />
        {FB_DIV}
        {INSTA_DIV}
        {WHATSAPP_DIV}
        {TELEGRAM_DIV}
        {btmbar}
    </div>// SHARE END

    // NOTI START
    const NOTI_DIV = <div className='Ieditcomp_div' style={commoneditstyle}>
        <Explain title={'Notification'} txt={'A notification bar on your page to give extra insights or highlight important info for your guests.'} />

        <div className='Details_notirow'>
            <label className="Details_switch">
                <input
                    type="checkbox"
                    checked={props.notificationbool}
                    onChange={() => {
                        if (!showsave) { updateBackup(); setShowsave(true); }
                        props.updateNotificationbool()
                    }}
                />
                <span className="Details_slider round" />
            </label>
            <div className='Details_notitxt'>
                {props.notificationbool ? 'Notification On' : 'Notification Off'}
            </div>
        </div>
        {props.notificationbool
            ? <>
                <div className="Details_grp">
                    {input_dom(
                        'Title',
                        '',
                        props.notificationtitle,
                        (e) => {
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            props.updateNotificationtitle(e.target.value)
                        },
                        'noti_id',
                        {},
                        false,
                        null,
                        {},
                        input_css)}

                </div>
                <div className="Details_grp">
                    {textarea_dom(
                        `Description ( ${props.notificationtxt.length}/800  )`,
                        '',
                        props.notificationtxt,
                        (e) => {
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            if (e.target.value.length < 801) { props.updateNotificationtxt(e.target.value) }
                        },
                        'description_id',
                        {},
                        !props.notificationbool,
                        null,
                        {},
                        txtarea_css,
                        5,
                        (e) => { setBs(e.key === 'Backspace' ? true : false) }
                    )}
                </div>
                <div className='Details_grp' >
                    {partialtitle_dom('Navigation Font-family', { margin: 0 })}
                    {inputdescribe_dom(`Font-family of location component. Please ensure it is readable for your guest.`, { margin: 0 })}
                    {twobtn_dom(
                        <>
                            <div style={{ pointerEvents: 'none', overflow: 'hidden', }} >Primary Font</div>
                            <div style={{ pointerEvents: 'none', overflow: 'hidden', fontSize: 12 }} >{` ( ${props.priff} ) `} </div>
                        </>,
                        <>
                            <div style={{ pointerEvents: 'none', overflow: 'hidden', }} >Secondary Font</div>
                            <div style={{ pointerEvents: 'none', overflow: 'hidden', fontSize: 12 }} >{` ( ${props.secff} ) `} </div>
                        </>,
                        'Primary Font', 'Secondary Font',
                        props.notiff === props.priff ? 'Primary Font' : 'Secondary Font',
                        (e) => {
                            if (!showsave) { updateBackup(); setShowsave(true); }
                            props.updateNotifftier(e)
                        },
                        { height: 55 }
                    )}
                </div>
            </>
            : null}
        {btmbar}
    </div>// NOTI END

    // ALT START - INACTIVE
    const ALT_DIV = <div className='Ieditcomp_div' style={commoneditstyle}>
        <Explain title={'Alternative Link'} txt={`Do you have another invitation card in a different language? If yes, you could link them together.`} />
        {allaltlinks_doms}
        <Addnewentry txt={'Add New Entry'} onClick={() => { props.updateAlticlinks([...props.alticlinks, "", ""]) }} />
    </div> // ALT END - INACTIVE

    const WEDDING_ITEMS_MAP = {
        'Names': WEDDINGNAMES_DIV,
        'Our Journey': OURJOURNEY_DIV,
        'Main Images': <Heroimages
            invitation_id={props.invitation_id}
            urlhandler={props.urlhandler}
            templatetype={props.templatetype}
            heroimglayout_map={props.heroimglayout_map}
            heroimgdevice_map={props.heroimgdevice_map}
            updateHeroimgdevice={props.updateHeroimgdevice}
            heroimglayout={props.heroimglayout}
            updateBackup={props.updateBackup}
            updateHeroimglayout={props.updateHeroimglayout}
            
            updateheroimgobj={props.updateheroimgobj}
            delsingleheroimgobj={props.delsingleheroimgobj}

            // for subpage Hero Image Effect & Style
            heroimgattr_map={props.heroimgattr_map}
            updateHeroimgattrmap={props.updateHeroimgattrmap}
            btmbar={btmbar}
            showsave={showsave}
            setShowsave={setShowsave}

        />,
        'Location': LOCATION_DIV,
        'Date Time': DATE_DIV({ countdown: props.countdown, updateDate: props.updateDatew, itype: itype, updateTime: props.updateTime, time: props.time, dt_type: props.dt_type, date_w: props.date_w, date_e: props.date_e, fc: props.fc, bgc: props.templatecolor }),
        'Q&A': <Questions
            device={device}
            partialwt={partialwt}
            updateBackup={updateBackup}
            clearBackup={clearBackup}
            restoreBackup={restoreBackup}
            showsave={showsave} setShowsave={setShowsave}
            qndata={qndata}
            updateQnas={props.updateQnas}
            saveQnas={props.saveQnas}
        />,
        'Schedules': <Schedules
            retrieveitineraries={props.retrieveitineraries}
            device={device}
            partialwt={partialwt}
            updateBackup={updateBackup}
            clearBackup={clearBackup}
            restoreBackup={restoreBackup}
            showsave={showsave} setShowsave={setShowsave}
            schedules={props.schedules}
            updateSchedules={props.updateSchedules}
            addSchedule={props.addSchedule}
            dragSaveschedule={props.dragSaveschedule}
            editSchedule={props.editSchedule}
            rmvSchedule={props.rmvSchedule}
            mapmode={props.mapmode}
            guestids={props.guestids}
            guestid_guestinfo_map={props.guestid_guestinfo_map}
        />,
        'Fonts': FONTS_DIV,
        'Notification': NOTI_DIV,
        'Sequence': <Sequence
            device={device}
            partialwt={partialwt}
            updateBackup={updateBackup}
            clearBackup={clearBackup}
            restoreBackup={restoreBackup}
            showsave={showsave} setShowsave={setShowsave}
            save={props.saveDisplayseq}
            displayseq={props.displayseq}
            displayonoffmap={props.displayonoffmap}
            displaytxtmap={props.displaytxtmap}
            updateDisplayseq={props.updateDisplayseq}
            updateDisplayonoffmap={props.updateDisplayonoffmap}
            updateDisplaytxtmap={props.updateDisplaytxtmap}
            revert={revert}
        />,
        'Contacts': <Contacts
            device={device}
            partialwt={partialwt}
            updateBackup={updateBackup}
            clearBackup={clearBackup}
            restoreBackup={restoreBackup}
            showsave={showsave} setShowsave={setShowsave}
            saveContacts={props.saveContacts}
            contacts={props.contacts}
            updateContacts={props.updateContacts}
        />,
        'Promote': <Promote
            device={device}
            partialwt={partialwt}
            updateBackup={updateBackup}
            clearBackup={clearBackup}
            restoreBackup={restoreBackup}
            showsave={showsave} setShowsave={setShowsave}
            promotedata={promotedata}
            updatePromote={props.updatePromote}
            savePromote={props.savePromote}
        />,

        'Share': SHARE_DIV,
        'Registry': <Registry
            device={device}
            partialwt={partialwt}
            updateBackup={updateBackup}
            clearBackup={clearBackup}
            restoreBackup={restoreBackup}
            showsave={showsave} setShowsave={setShowsave}
            registrydata={registrydata}
            updateRegistry={props.updateRegistry}
            saveRegistry={props.saveRegistry}
        />,
        'Party': <Party
            device={device}
            partialwt={partialwt}
            updateBackup={updateBackup}
            clearBackup={clearBackup}
            restoreBackup={restoreBackup}
            showsave={showsave} setShowsave={setShowsave}
            partydata={partydata}
            partyproperties={partyproperties}
            updateSinglepartymember={props.updateSinglepartymember}
            saveSinglepartymember={props.saveSinglepartymember}
            updatePartyproperties={props.updatePartyproperties}

        />,

        // 'Openings': <Openings
        //     openingnames={props.openingnames} openingobjs={props.openingobjs} openingclosing={props.openingclosing} openingstoryobjs={props.openingstoryobjs} openingtype={props.openingtype} animationobjs={props.animationobjs} animationtype={props.animationtype}
        //     updateOpeningnames={props.updateOpeningnames} // store names for Convo
        //     updateOpeningobjs={props.updateOpeningobjs} // update for Convo obj only
        //     updateOpeningstoryobjs={props.updateOpeningstoryobjs} // update for Story obj only
        //     updateOpeningtype={props.updateOpeningtype} // Convo or Story
        //     updateAnimationobjs={props.updateAnimationobjs}
        //     updateAnimationtype={props.updateAnimationtype}
        //     updateOpeningclosing={props.updateOpeningclosing} // closing of opening
        // />
        // 'Alternative Links': ALT_DIV,
    }

    const onoff_signal = (name, i) => {
        // props.displayonoffmap && props.displayonoffmap[name]
        if (props.displayonoffmap) {
            const { displayonoffmap } = props
            if (name === 'Q&A') {
                return <div
                    key={name + '_index'}
                    style={{
                        display: 'flex',
                        width: 6,
                        height: 6,
                        margin: '15px 15px 10px 0px',
                        position: 'absolute',
                        borderRadius: 50,
                        top: 0,
                        right: 0,
                        backgroundColor: displayonoffmap['qna'] ? 'var(--donegreen)' : 'var(--mainpink)'
                    }}
                />
            }
            else if (name === 'Schedules') {
                return <div
                    key={name + '_index'}
                    style={{
                        display: 'flex',
                        width: 6,
                        height: 6,
                        margin: '15px 15px 10px 0px',
                        position: 'absolute',
                        borderRadius: 50,
                        top: 0,
                        right: 0,
                        backgroundColor: displayonoffmap['schedule'] ? 'var(--donegreen)' : 'var(--mainpink)'
                    }}
                />
            }
            else if (name === 'Date Time') {
                return <div
                    key={name + '_index'}
                    style={{
                        display: 'flex',
                        width: 6,
                        height: 6,
                        margin: '15px 15px 10px 0px',
                        position: 'absolute',
                        borderRadius: 50,
                        top: 0,
                        right: 0,
                        backgroundColor: 'var(--firmgreen)'
                    }}
                />
            }
            else if (name === 'Our Journey') {

                return <div
                    key={name + '_index'}
                    style={{
                        display: 'flex',
                        position: 'absolute',
                        padding: '15px 15px 10px 0px',
                        flexDirection: 'column',
                        top: 0,
                        right: 0,
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            width: 6,
                            height: 6,
                            borderRadius: 50,
                            marginBottom: 5,
                            top: 0,
                            right: 0,
                            backgroundColor: 'var(--firmgreen)'
                        }}
                    />
                    <div
                        style={{
                            display: 'flex',
                            width: 6,
                            height: 6,
                            borderRadius: 50,
                            marginBottom: 5,
                            top: 0,
                            right: 0,
                            backgroundColor: displayonoffmap['howwemet'] ? 'var(--donegreen)' : 'var(--mainpink)'
                        }}
                    />
                    <div
                        style={{
                            display: 'flex',
                            width: 6,
                            height: 6,
                            borderRadius: 50,
                            marginBottom: 5,
                            top: 0,
                            right: 0,
                            backgroundColor: displayonoffmap['proposal'] ? 'var(--donegreen)' : 'var(--mainpink)'
                        }}
                    />
                </div>
            }
            else if (name === 'Main Images') {

            }
            else if (name === 'Location') {
                return <div
                    key={name + '_index'}
                    style={{
                        display: 'flex',
                        position: 'absolute',
                        padding: '15px 15px 10px 0px',
                        flexDirection: 'column',
                        top: 0,
                        right: 0,

                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            width: 6,
                            height: 6,
                            borderRadius: 50,
                            marginBottom: 5,
                            top: 0,
                            right: 0,
                            backgroundColor: 'var(--firmgreen)'
                        }}
                    />
                    <div
                        style={{
                            display: 'flex',
                            width: 6,
                            height: 6,
                            borderRadius: 50,
                            marginBottom: 5,
                            top: 0,
                            right: 0,
                            backgroundColor: displayonoffmap['map'] ? 'var(--donegreen)' : 'var(--mainpink)'
                        }}
                    />
                </div>
            }
            else if (name === 'Names') {
                return <div
                    key={name + '_index'}
                    style={{
                        display: 'flex',
                        width: 6,
                        height: 6,
                        margin: '15px 15px 10px 0px',
                        position: 'absolute',
                        borderRadius: 50,
                        top: 0,
                        right: 0,
                        backgroundColor: 'var(--firmgreen)'
                    }}
                />
            }
            else return <div key={name + i} />
        }

    }

    const first = ['Names', 'Our Journey', 'Main Images', 'Location', 'Date Time', 'Q&A', 'Schedules']
    const second = ['Fonts', 'Notification', 'Sequence']
    const third = ['Contacts', 'Promote', 'Share', 'Registry']

    const squaremenus = {
        'Wedding': <div id={selectedsubpage.length === 0 ? "Ieditcomp_weddinggridroot" : ''}  >
            {selectedsubpage.length > 0
                ? null
                : Object.keys(WEDDING_ITEMS_MAP).map((itemtxt, index) => {
                    return <li
                        className="Ieditcomp_sq"
                        key={itemtxt + index}
                        onClick={() => {
                            if (itemtxt === selectedsubpage) {
                                setSelectedsubpage('');
                                props.updateNowshowing('');
                            }
                            else {
                                setSelectedsubpage(itemtxt);
                                props.updateNowshowing(itemtxt);
                            }
                        }}
                    >
                        <div className='Ieditcomp_sqtop'>{TYPE_ICON_MAP[itemtxt]}</div>
                        <div className='Ieditcomp_sqbtm'>{itemtxt}</div>
                        {/* {onoff_signal(itemtxt, index)} */}
                    </li>
                })}
        </div>
    }[itype]

    return <div id="Ieditcomp_root">
        {squaremenus}
        {selectedsubpage.length > 0
            ? <div id="Ieditcomp_contentroot">
                <Highlighttitle icon={TYPE_ICON_MAP[selectedsubpage]} selectedsubpage={selectedsubpage} onClick={updateSubpageback} />
                {WEDDING_ITEMS_MAP[selectedsubpage]}
            </div>
            : null}

    </div>

}

export default Details